// // // // // // // // // // // import { useState } from "react";
// // // // // // // // // // // import { Box, Card, CardContent, Typography, TextField, Button, MenuItem, Select, FormControl, InputLabel, Grid } from "@mui/material";
// // // // // // // // // // // import { useTranslation } from "react-i18next";

// // // // // // // // // // // const NewIssueScreen = () => {
// // // // // // // // // // //   const { t } = useTranslation();
// // // // // // // // // // //   const [formData, setFormData] = useState({
// // // // // // // // // // //     title: "",
// // // // // // // // // // //     description: "",
// // // // // // // // // // //     priority: "MEDIUM",
// // // // // // // // // // //   });

// // // // // // // // // // //   return (
// // // // // // // // // // //     <Box display="flex" justifyContent="center" mt={4}>
// // // // // // // // // // //       <Card sx={{ width: "100%", maxWidth: 700, elevation: 12 }}>
// // // // // // // // // // //         <CardContent>
// // // // // // // // // // //           <Typography variant="h5" mb={3} fontWeight="bold">{t("NEW ISSUE REPORT")}</Typography>
// // // // // // // // // // //           <form>
// // // // // // // // // // //             <Grid container spacing={2}>
// // // // // // // // // // //               <Grid item xs={12}>
// // // // // // // // // // //                 <TextField fullWidth label={t("TITLE")} required value={formData.title} />
// // // // // // // // // // //               </Grid>
// // // // // // // // // // //               <Grid item xs={12}>
// // // // // // // // // // //                 <TextField fullWidth multiline rows={4} label={t("DESCRIPTION")} required value={formData.description} />
// // // // // // // // // // //               </Grid>
// // // // // // // // // // //               <Grid item xs={12}>
// // // // // // // // // // //                 <FormControl fullWidth>
// // // // // // // // // // //                   <InputLabel>{t("PRIORITY")}</InputLabel>
// // // // // // // // // // //                   <Select value={formData.priority} label={t("PRIORITY")}>
// // // // // // // // // // //                     <MenuItem value="LOW">{t("Low")}</MenuItem>
// // // // // // // // // // //                     <MenuItem value="MEDIUM">{t("Medium")}</MenuItem>
// // // // // // // // // // //                     <MenuItem value="HIGH">{t("High")}</MenuItem>
// // // // // // // // // // //                   </Select>
// // // // // // // // // // //                 </FormControl>
// // // // // // // // // // //               </Grid>
// // // // // // // // // // //               <Grid item xs={12}>
// // // // // // // // // // //                 <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>{t("SUBMIT")}</Button>
// // // // // // // // // // //               </Grid>
// // // // // // // // // // //             </Grid>
// // // // // // // // // // //           </form>
// // // // // // // // // // //         </CardContent>
// // // // // // // // // // //       </Card>
// // // // // // // // // // //     </Box>
// // // // // // // // // // //   );
// // // // // // // // // // // };

// // // // // // // // // // // export default NewIssueScreen;



// // // // // // // // // // import { useState } from "react";
// // // // // // // // // // import { 
// // // // // // // // // //   Box, Card, CardContent, Typography, TextField, 
// // // // // // // // // //   Button, MenuItem, Select, FormControl, InputLabel, Grid 
// // // // // // // // // // } from "@mui/material";
// // // // // // // // // // import { useTranslation } from "react-i18next";
// // // // // // // // // // import axiosClient from "../axiosClient";

// // // // // // // // // // const NewIssueScreen = () => {
// // // // // // // // // //   const { t } = useTranslation();
  
// // // // // // // // // //   // 1. Define state to hold the input values
// // // // // // // // // //   const [formData, setFormData] = useState({
// // // // // // // // // //     title: "",
// // // // // // // // // //     description: "",
// // // // // // // // // //     priority: "Medium",
// // // // // // // // // //   });

// // // // // // // // // //   // 2. Function to update state when you type
// // // // // // // // // //   const handleChange = (e) => {
// // // // // // // // // //     const { name, value } = e.target;
// // // // // // // // // //     setFormData((prev) => ({
// // // // // // // // // //       ...prev,
// // // // // // // // // //       [name]: value,
// // // // // // // // // //     }));
// // // // // // // // // //   };

// // // // // // // // // //   const handleSubmit = async (e) => {
// // // // // // // // // //     e.preventDefault();
// // // // // // // // // //     try {
// // // // // // // // // //       // Logic to send data to your backend
// // // // // // // // // //       await axiosClient.post("api/issues/", formData);
// // // // // // // // // //       alert(t("Issue submitted successfully"));
// // // // // // // // // //       setFormData({ title: "", description: "", priority: "Medium" });
// // // // // // // // // //     } catch (err) {
// // // // // // // // // //       console.error("Error submitting issue:", err);
// // // // // // // // // //     }
// // // // // // // // // //   };

// // // // // // // // // //   return (
// // // // // // // // // //     <Box display="flex" justifyContent="center" mt={4}>
// // // // // // // // // //       <Card sx={{ width: "100%", maxWidth: 700, elevation: 12 }}>
// // // // // // // // // //         <CardContent>
// // // // // // // // // //           <Typography variant="h5" mb={3} fontWeight="bold" align="center">
// // // // // // // // // //             {t("NEW ISSUE REPORT")}
// // // // // // // // // //           </Typography>
          
// // // // // // // // // //           <form onSubmit={handleSubmit}>
// // // // // // // // // //             <Grid container spacing={2}>
// // // // // // // // // //               <Grid item xs={12}>
// // // // // // // // // //                 {/* 3. Added 'name', 'value', and 'onChange' to enable typing */}
// // // // // // // // // //                 <TextField 
// // // // // // // // // //                   fullWidth 
// // // // // // // // // //                   label={t("TITLE *")} 
// // // // // // // // // //                   name="title"
// // // // // // // // // //                   value={formData.title} 
// // // // // // // // // //                   onChange={handleChange}
// // // // // // // // // //                   required 
// // // // // // // // // //                 />
// // // // // // // // // //               </Grid>
// // // // // // // // // //               <Grid item xs={12}>
// // // // // // // // // //                 {/* 3. Added 'name', 'value', and 'onChange' for description */}
// // // // // // // // // //                 <TextField 
// // // // // // // // // //                   fullWidth 
// // // // // // // // // //                   multiline 
// // // // // // // // // //                   rows={4} 
// // // // // // // // // //                   label={t("DESCRIPTION *")} 
// // // // // // // // // //                   name="description"
// // // // // // // // // //                   value={formData.description} 
// // // // // // // // // //                   onChange={handleChange}
// // // // // // // // // //                   required 
// // // // // // // // // //                 />
// // // // // // // // // //               </Grid>
// // // // // // // // // //               <Grid item xs={12}>
// // // // // // // // // //                 <FormControl fullWidth>
// // // // // // // // // //                   <InputLabel id="priority-label">{t("PRIORITY")}</InputLabel>
// // // // // // // // // //                   <Select 
// // // // // // // // // //                     labelId="priority-label"
// // // // // // // // // //                     name="priority"
// // // // // // // // // //                     value={formData.priority} 
// // // // // // // // // //                     label={t("PRIORITY")}
// // // // // // // // // //                     onChange={handleChange}
// // // // // // // // // //                   >
// // // // // // // // // //                     <MenuItem value="Low">{t("Low")}</MenuItem>
// // // // // // // // // //                     <MenuItem value="Medium">{t("Medium")}</MenuItem>
// // // // // // // // // //                     <MenuItem value="High">{t("High")}</MenuItem>
// // // // // // // // // //                   </Select>
// // // // // // // // // //                 </FormControl>
// // // // // // // // // //               </Grid>
// // // // // // // // // //               <Grid item xs={12}>
// // // // // // // // // //                 <Button 
// // // // // // // // // //                   type="submit" 
// // // // // // // // // //                   variant="contained" 
// // // // // // // // // //                   fullWidth 
// // // // // // // // // //                   sx={{ mt: 2, py: 1.5, fontWeight: "bold" }}
// // // // // // // // // //                 >
// // // // // // // // // //                   {t("SUBMIT")}
// // // // // // // // // //                 </Button>
// // // // // // // // // //               </Grid>
// // // // // // // // // //             </Grid>
// // // // // // // // // //           </form>
// // // // // // // // // //         </CardContent>
// // // // // // // // // //       </Card>
// // // // // // // // // //     </Box>
// // // // // // // // // //   );
// // // // // // // // // // };

// // // // // // // // // // export default NewIssueScreen;


// // // // // // // // // // import { useState } from "react";
// // // // // // // // // // import { 
// // // // // // // // // //   Box, Card, CardContent, Typography, TextField, 
// // // // // // // // // //   Button, MenuItem, Select, FormControl, InputLabel, Grid 
// // // // // // // // // // } from "@mui/material";
// // // // // // // // // // import { useTranslation } from "react-i18next";
// // // // // // // // // // import axiosClient from "../axiosClient";

// // // // // // // // // // const NewIssueScreen = () => {
// // // // // // // // // //   const { t } = useTranslation();
  
// // // // // // // // // //   // 1. Updated state to include room_number
// // // // // // // // // //   const [formData, setFormData] = useState({
// // // // // // // // // //     title: "",
// // // // // // // // // //     description: "",
// // // // // // // // // //     priority: "Medium",
// // // // // // // // // //     room_number: "", // 🆕 Added field
// // // // // // // // // //   });

// // // // // // // // // //   // 2. Function to update state when you type
// // // // // // // // // //   const handleChange = (e) => {
// // // // // // // // // //     const { name, value } = e.target;
// // // // // // // // // //     setFormData((prev) => ({
// // // // // // // // // //       ...prev,
// // // // // // // // // //       [name]: value,
// // // // // // // // // //     }));
// // // // // // // // // //   };

// // // // // // // // // //   const handleSubmit = async (e) => {
// // // // // // // // // //     e.preventDefault();
// // // // // // // // // //     try {
// // // // // // // // // //       // Logic to send data to your backend
// // // // // // // // // //       await axiosClient.post("api/issues/", formData);
// // // // // // // // // //       alert(t("Issue submitted successfully"));
// // // // // // // // // //       // Reset form including room_number
// // // // // // // // // //       setFormData({ title: "", description: "", priority: "Medium", room_number: "" });
// // // // // // // // // //     } catch (err) {
// // // // // // // // // //       console.error("Error submitting issue:", err);
// // // // // // // // // //     }
// // // // // // // // // //   };

// // // // // // // // // //   return (
// // // // // // // // // //     <Box display="flex" justifyContent="center" mt={4}>
// // // // // // // // // //       <Card sx={{ width: "100%", maxWidth: 700, elevation: 12 }}>
// // // // // // // // // //         <CardContent>
// // // // // // // // // //           <Typography variant="h5" mb={3} fontWeight="bold" align="center">
// // // // // // // // // //             {t("NEW ISSUE REPORT")}
// // // // // // // // // //           </Typography>
          
// // // // // // // // // //           <form onSubmit={handleSubmit}>
// // // // // // // // // //             <Grid container spacing={2}>
// // // // // // // // // //               <Grid item xs={12} sm={8}>
// // // // // // // // // //                 <TextField 
// // // // // // // // // //                   fullWidth 
// // // // // // // // // //                   label={t("TITLE *")} 
// // // // // // // // // //                   name="title"
// // // // // // // // // //                   value={formData.title} 
// // // // // // // // // //                   onChange={handleChange}
// // // // // // // // // //                   required 
// // // // // // // // // //                 />
// // // // // // // // // //               </Grid>

// // // // // // // // // //               {/* 🆕 Added Room Number Field */}
// // // // // // // // // //               <Grid item xs={12} sm={4}>
// // // // // // // // // //                 <TextField 
// // // // // // // // // //                   fullWidth 
// // // // // // // // // //                   label={t("ROOM NUMBER")} 
// // // // // // // // // //                   name="room_number"
// // // // // // // // // //                   value={formData.room_number} 
// // // // // // // // // //                   onChange={handleChange}
// // // // // // // // // //                   placeholder="e.g. 101"
// // // // // // // // // //                 />
// // // // // // // // // //               </Grid>

// // // // // // // // // //               <Grid item xs={12}>
// // // // // // // // // //                 <TextField 
// // // // // // // // // //                   fullWidth 
// // // // // // // // // //                   multiline 
// // // // // // // // // //                   rows={4} 
// // // // // // // // // //                   label={t("DESCRIPTION *")} 
// // // // // // // // // //                   name="description"
// // // // // // // // // //                   value={formData.description} 
// // // // // // // // // //                   onChange={handleChange}
// // // // // // // // // //                   required 
// // // // // // // // // //                 />
// // // // // // // // // //               </Grid>

// // // // // // // // // //               <Grid item xs={12}>
// // // // // // // // // //                 <FormControl fullWidth>
// // // // // // // // // //                   <InputLabel id="priority-label">{t("PRIORITY")}</InputLabel>
// // // // // // // // // //                   <Select 
// // // // // // // // // //                     labelId="priority-label"
// // // // // // // // // //                     name="priority"
// // // // // // // // // //                     value={formData.priority} 
// // // // // // // // // //                     label={t("PRIORITY")}
// // // // // // // // // //                     onChange={handleChange}
// // // // // // // // // //                   >
// // // // // // // // // //                     <MenuItem value="Low">{t("Low")}</MenuItem>
// // // // // // // // // //                     <MenuItem value="Medium">{t("Medium")}</MenuItem>
// // // // // // // // // //                     <MenuItem value="High">{t("High")}</MenuItem>
// // // // // // // // // //                   </Select>
// // // // // // // // // //                 </FormControl>
// // // // // // // // // //               </Grid>

// // // // // // // // // //               <Grid item xs={12}>
// // // // // // // // // //                 <Button 
// // // // // // // // // //                   type="submit" 
// // // // // // // // // //                   variant="contained" 
// // // // // // // // // //                   fullWidth 
// // // // // // // // // //                   sx={{ mt: 2, py: 1.5, fontWeight: "bold" }}
// // // // // // // // // //                 >
// // // // // // // // // //                   {t("SUBMIT")}
// // // // // // // // // //                 </Button>
// // // // // // // // // //               </Grid>
// // // // // // // // // //             </Grid>
// // // // // // // // // //           </form>
// // // // // // // // // //         </CardContent>
// // // // // // // // // //       </Card>
// // // // // // // // // //     </Box>
// // // // // // // // // //   );
// // // // // // // // // // };

// // // // // // // // // // export default NewIssueScreen;

// // // // // // // // // import { useState, useEffect } from "react";
// // // // // // // // // import { 
// // // // // // // // //   Box, Card, CardContent, Typography, TextField, 
// // // // // // // // //   Button, MenuItem, Select, FormControl, InputLabel, Grid, CircularProgress 
// // // // // // // // // } from "@mui/material";
// // // // // // // // // import { useTranslation } from "react-i18next";
// // // // // // // // // import axiosClient from "../axiosClient";

// // // // // // // // // const NewIssueScreen = () => {
// // // // // // // // //   const { t } = useTranslation();
  
// // // // // // // // //   // 1. Expanded state
// // // // // // // // //   const [formData, setFormData] = useState({
// // // // // // // // //     title: "",
// // // // // // // // //     description: "",
// // // // // // // // //     priority: "Medium",
// // // // // // // // //     room_number: "",
// // // // // // // // //     employee_type: "", // To store if user chose 'Technician' or 'Maid'
// // // // // // // // //     assigned_to: "",   // The specific ID of the selected employee
// // // // // // // // //   });

// // // // // // // // //   const [allEmployees, setAllEmployees] = useState([]); // Raw data from backend
// // // // // // // // //   const [filteredEmployees, setFilteredEmployees] = useState([]); // Filtered by type
// // // // // // // // //   const [loading, setLoading] = useState(true);

// // // // // // // // //   // 2. Fetch all users from the backend on load
// // // // // // // // //   useEffect(() => {
// // // // // // // // //     const fetchUsers = async () => {
// // // // // // // // //       try {
// // // // // // // // //         const response = await axiosClient.get("auth/users/");
// // // // // // // // //         // We only want users who are either technicians or maids
// // // // // // // // //         const staff = response.data.filter(user => 
// // // // // // // // //           user.user_role === "TECHNICIAN" || user.user_role === "MAID"
// // // // // // // // //         );
// // // // // // // // //         setAllEmployees(staff);
// // // // // // // // //       } catch (err) {
// // // // // // // // //         console.error("Error fetching staff:", err);
// // // // // // // // //       } finally {
// // // // // // // // //         setLoading(false);
// // // // // // // // //       }
// // // // // // // // //     };
// // // // // // // // //     fetchUsers();
// // // // // // // // //   }, []);

// // // // // // // // //   // 3. Update filtered list whenever employee_type changes
// // // // // // // // //   useEffect(() => {
// // // // // // // // //     if (formData.employee_type) {
// // // // // // // // //       const filtered = allEmployees.filter(emp => emp.user_role === formData.employee_type);
// // // // // // // // //       setFilteredEmployees(filtered);
// // // // // // // // //       // Reset the specific assignment if the type changes
// // // // // // // // //       setFormData(prev => ({ ...prev, assigned_to: "" }));
// // // // // // // // //     } else {
// // // // // // // // //       setFilteredEmployees([]);
// // // // // // // // //     }
// // // // // // // // //   }, [formData.employee_type, allEmployees]);

// // // // // // // // //   const handleChange = (e) => {
// // // // // // // // //     const { name, value } = e.target;
// // // // // // // // //     setFormData((prev) => ({
// // // // // // // // //       ...prev,
// // // // // // // // //       [name]: value,
// // // // // // // // //     }));
// // // // // // // // //   };

// // // // // // // // //   const handleSubmit = async (e) => {
// // // // // // // // //     e.preventDefault();
// // // // // // // // //     try {
// // // // // // // // //       // Map 'assigned_to' to 'assigned_technician' for your backend's expected format
// // // // // // // // //       const submitData = {
// // // // // // // // //         ...formData,
// // // // // // // // //         assigned_technician: formData.assigned_to 
// // // // // // // // //       };
// // // // // // // // //       await axiosClient.post("api/issues/", submitData);
// // // // // // // // //       alert(t("Issue submitted successfully"));
// // // // // // // // //       setFormData({ 
// // // // // // // // //         title: "", 
// // // // // // // // //         description: "", 
// // // // // // // // //         priority: "Medium", 
// // // // // // // // //         room_number: "", 
// // // // // // // // //         employee_type: "", 
// // // // // // // // //         assigned_to: "" 
// // // // // // // // //       });
// // // // // // // // //     } catch (err) {
// // // // // // // // //       console.error("Error submitting issue:", err);
// // // // // // // // //       alert(t("Failed to submit issue"));
// // // // // // // // //     }
// // // // // // // // //   };

// // // // // // // // //   return (
// // // // // // // // //     <Box display="flex" justifyContent="center" mt={4}>
// // // // // // // // //       <Card sx={{ width: "100%", maxWidth: 800, elevation: 12 }}>
// // // // // // // // //         <CardContent>
// // // // // // // // //           <Typography variant="h5" mb={3} fontWeight="bold" align="center">
// // // // // // // // //             {t("NEW ISSUE REPORT")}
// // // // // // // // //           </Typography>
          
// // // // // // // // //           <form onSubmit={handleSubmit}>
// // // // // // // // //             <Grid container spacing={2}>
// // // // // // // // //               {/* Title and Room Number */}
// // // // // // // // //               <Grid item xs={12} sm={8}>
// // // // // // // // //                 <TextField fullWidth label={t("TITLE *")} name="title" value={formData.title} onChange={handleChange} required />
// // // // // // // // //               </Grid>
// // // // // // // // //               <Grid item xs={12} sm={4}>
// // // // // // // // //                 <TextField fullWidth label={t("ROOM NUMBER")} name="room_number" value={formData.room_number} onChange={handleChange} placeholder="e.g. 101" />
// // // // // // // // //               </Grid>

// // // // // // // // //               {/* Description */}
// // // // // // // // //               <Grid item xs={12}>
// // // // // // // // //                 <TextField fullWidth multiline rows={4} label={t("DESCRIPTION *")} name="description" value={formData.description} onChange={handleChange} required />
// // // // // // // // //               </Grid>

// // // // // // // // //               {/* Priority */}
// // // // // // // // //               <Grid item xs={12} sm={4}>
// // // // // // // // //                 <FormControl fullWidth>
// // // // // // // // //                   <InputLabel>{t("PRIORITY")}</InputLabel>
// // // // // // // // //                   <Select name="priority" value={formData.priority} label={t("PRIORITY")} onChange={handleChange}>
// // // // // // // // //                     <MenuItem value="Low">{t("Low")}</MenuItem>
// // // // // // // // //                     <MenuItem value="Medium">{t("Medium")}</MenuItem>
// // // // // // // // //                     <MenuItem value="High">{t("High")}</MenuItem>
// // // // // // // // //                   </Select>
// // // // // // // // //                 </FormControl>
// // // // // // // // //               </Grid>

// // // // // // // // //               {/* NEW: Step 1 - Choose Employee Type */}
// // // // // // // // //               <Grid item xs={12} sm={4}>
// // // // // // // // //                 <FormControl fullWidth>
// // // // // // // // //                   <InputLabel>{t("EMPLOYEE TYPE")}</InputLabel>
// // // // // // // // //                   <Select name="employee_type" value={formData.employee_type} label={t("EMPLOYEE TYPE")} onChange={handleChange}>
// // // // // // // // //                     <MenuItem value="TECHNICIAN">{t("Technician")}</MenuItem>
// // // // // // // // //                     <MenuItem value="MAID">{t("Maid")}</MenuItem>
// // // // // // // // //                   </Select>
// // // // // // // // //                 </FormControl>
// // // // // // // // //               </Grid>

// // // // // // // // //               {/* NEW: Step 2 - Choose Specific Employee based on Step 1 */}
// // // // // // // // //               <Grid item xs={12} sm={4}>
// // // // // // // // //                 <FormControl fullWidth disabled={!formData.employee_type || loading}>
// // // // // // // // //                   <InputLabel>{loading ? <CircularProgress size={20} /> : t("ASSIGN TO")}</InputLabel>
// // // // // // // // //                   <Select 
// // // // // // // // //                     name="assigned_to" 
// // // // // // // // //                     value={formData.assigned_to} 
// // // // // // // // //                     label={t("ASSIGN TO")} 
// // // // // // // // //                     onChange={handleChange}
// // // // // // // // //                   >
// // // // // // // // //                     {filteredEmployees.map((emp) => (
// // // // // // // // //                       <MenuItem key={emp.id} value={emp.id}>
// // // // // // // // //                         {emp.first_name} {emp.last_name}
// // // // // // // // //                       </MenuItem>
// // // // // // // // //                     ))}
// // // // // // // // //                     {filteredEmployees.length === 0 && formData.employee_type && (
// // // // // // // // //                        <MenuItem disabled>{t("No employees found")}</MenuItem>
// // // // // // // // //                     )}
// // // // // // // // //                   </Select>
// // // // // // // // //                 </FormControl>
// // // // // // // // //               </Grid>

// // // // // // // // //               <Grid item xs={12}>
// // // // // // // // //                 <Button type="submit" variant="contained" fullWidth sx={{ mt: 2, py: 1.5, fontWeight: "bold" }}>
// // // // // // // // //                   {t("SUBMIT")}
// // // // // // // // //                 </Button>
// // // // // // // // //               </Grid>
// // // // // // // // //             </Grid>
// // // // // // // // //           </form>
// // // // // // // // //         </CardContent>
// // // // // // // // //       </Card>
// // // // // // // // //     </Box>
// // // // // // // // //   );
// // // // // // // // // };

// // // // // // // // // export default NewIssueScreen;

// // // // // // // // import { useState, useEffect } from "react";
// // // // // // // // import { 
// // // // // // // //   Box, Card, CardContent, Typography, TextField, 
// // // // // // // //   Button, MenuItem, Select, FormControl, InputLabel, Grid, CircularProgress 
// // // // // // // // } from "@mui/material";
// // // // // // // // import { useTranslation } from "react-i18next";
// // // // // // // // import axiosClient from "../axiosClient";

// // // // // // // // const NewIssueScreen = () => {
// // // // // // // //   const { t } = useTranslation();
  
// // // // // // // //   const [formData, setFormData] = useState({
// // // // // // // //     title: "",
// // // // // // // //     description: "",
// // // // // // // //     priority: "Medium",
// // // // // // // //     room_number: "",
// // // // // // // //     employee_type: "", // Used to filter the list
// // // // // // // //     assigned_to: "",   // Stores the final User ID
// // // // // // // //   });

// // // // // // // //   const [allEmployees, setAllEmployees] = useState([]);
// // // // // // // //   const [filteredEmployees, setFilteredEmployees] = useState([]);
// // // // // // // //   const [loading, setLoading] = useState(true);

// // // // // // // //   // Fetch all staff members when the screen loads
// // // // // // // //   useEffect(() => {
// // // // // // // //     const fetchUsers = async () => {
// // // // // // // //       try {
// // // // // // // //         const response = await axiosClient.get("auth/users/");
// // // // // // // //         // Filter out only Technicians and Maids from the master user list
// // // // // // // //         const staff = response.data.filter(user => 
// // // // // // // //           user.user_role === "TECHNICIAN" || user.user_role === "MAID"
// // // // // // // //         );
// // // // // // // //         setAllEmployees(staff);
// // // // // // // //       } catch (err) {
// // // // // // // //         console.error("Error fetching staff:", err);
// // // // // // // //       } finally {
// // // // // // // //         setLoading(false);
// // // // // // // //       }
// // // // // // // //     };
// // // // // // // //     fetchUsers();
// // // // // // // //   }, []);

// // // // // // // //   // Update the dropdown list whenever the user switches between Technician/Maid
// // // // // // // //   useEffect(() => {
// // // // // // // //     if (formData.employee_type) {
// // // // // // // //       const filtered = allEmployees.filter(emp => emp.user_role === formData.employee_type);
// // // // // // // //       setFilteredEmployees(filtered);
// // // // // // // //       setFormData(prev => ({ ...prev, assigned_to: "" })); // Clear previous selection
// // // // // // // //     }
// // // // // // // //   }, [formData.employee_type, allEmployees]);

// // // // // // // //   const handleChange = (e) => {
// // // // // // // //     const { name, value } = e.target;
// // // // // // // //     setFormData((prev) => ({
// // // // // // // //       ...prev,
// // // // // // // //       [name]: value,
// // // // // // // //     }));
// // // // // // // //   };

// // // // // // // //   const handleSubmit = async (e) => {
// // // // // // // //     e.preventDefault();
// // // // // // // //     try {
// // // // // // // //       const submitData = {
// // // // // // // //         title: formData.title,
// // // // // // // //         description: formData.description,
// // // // // // // //         priority: formData.priority,
// // // // // // // //         room_number: formData.room_number,
// // // // // // // //         assigned_technician: formData.assigned_to, // Mapping to your backend field
// // // // // // // //       };
// // // // // // // //       await axiosClient.post("api/issues/", submitData);
// // // // // // // //       alert(t("Issue submitted successfully"));
// // // // // // // //       setFormData({ title: "", description: "", priority: "Medium", room_number: "", employee_type: "", assigned_to: "" });
// // // // // // // //     } catch (err) {
// // // // // // // //       console.error("Error submitting issue:", err);
// // // // // // // //     }
// // // // // // // //   };

// // // // // // // //   return (
// // // // // // // //     <Box display="flex" justifyContent="center" mt={4}>
// // // // // // // //       <Card sx={{ width: "100%", maxWidth: 800, elevation: 12, bgcolor: "#24242b", color: "white" }}>
// // // // // // // //         <CardContent>
// // // // // // // //           <Typography variant="h5" mb={3} fontWeight="bold" align="center">
// // // // // // // //             {t("NEW ISSUE REPORT")}
// // // // // // // //           </Typography>
          
// // // // // // // //           <form onSubmit={handleSubmit}>
// // // // // // // //             <Grid container spacing={2}>
// // // // // // // //               <Grid item xs={12} sm={8}>
// // // // // // // //                 <TextField fullWidth label={t("TITLE *")} name="title" value={formData.title} onChange={handleChange} required variant="outlined" />
// // // // // // // //               </Grid>

// // // // // // // //               <Grid item xs={12} sm={4}>
// // // // // // // //                 <TextField fullWidth label={t("ROOM NUMBER")} name="room_number" value={formData.room_number} onChange={handleChange} placeholder="e.g. 101" />
// // // // // // // //               </Grid>

// // // // // // // //               <Grid item xs={12}>
// // // // // // // //                 <TextField fullWidth multiline rows={4} label={t("DESCRIPTION *")} name="description" value={formData.description} onChange={handleChange} required />
// // // // // // // //               </Grid>

// // // // // // // //               <Grid item xs={12} sm={4}>
// // // // // // // //                 <FormControl fullWidth>
// // // // // // // //                   <InputLabel>{t("PRIORITY")}</InputLabel>
// // // // // // // //                   <Select name="priority" value={formData.priority} label={t("PRIORITY")} onChange={handleChange}>
// // // // // // // //                     <MenuItem value="Low">{t("Low")}</MenuItem>
// // // // // // // //                     <MenuItem value="Medium">{t("Medium")}</MenuItem>
// // // // // // // //                     <MenuItem value="High">{t("High")}</MenuItem>
// // // // // // // //                   </Select>
// // // // // // // //                 </FormControl>
// // // // // // // //               </Grid>

// // // // // // // //               {/* STEP 1: Select Type */}
// // // // // // // //               <Grid item xs={12} sm={4}>
// // // // // // // //                 <FormControl fullWidth>
// // // // // // // //                   <InputLabel>{t("EMPLOYEE TYPE")}</InputLabel>
// // // // // // // //                   <Select name="employee_type" value={formData.employee_type} label={t("EMPLOYEE TYPE")} onChange={handleChange}>
// // // // // // // //                     <MenuItem value="TECHNICIAN">{t("Technician")}</MenuItem>
// // // // // // // //                     <MenuItem value="MAID">{t("Maid")}</MenuItem>
// // // // // // // //                   </Select>
// // // // // // // //                 </FormControl>
// // // // // // // //               </Grid>

// // // // // // // //               {/* STEP 2: Select Name based on Type */}
// // // // // // // //               <Grid item xs={12} sm={4}>
// // // // // // // //                 <FormControl fullWidth disabled={!formData.employee_type || loading}>
// // // // // // // //                   <InputLabel>{loading ? <CircularProgress size={20} /> : t("ASSIGN TO")}</InputLabel>
// // // // // // // //                   <Select 
// // // // // // // //                     name="assigned_to" 
// // // // // // // //                     value={formData.assigned_to} 
// // // // // // // //                     label={t("ASSIGN TO")} 
// // // // // // // //                     onChange={handleChange}
// // // // // // // //                     required
// // // // // // // //                   >
// // // // // // // //                     {filteredEmployees.map((emp) => (
// // // // // // // //                       <MenuItem key={emp.id} value={emp.id}>
// // // // // // // //                         {emp.first_name} {emp.last_name}
// // // // // // // //                       </MenuItem>
// // // // // // // //                     ))}
// // // // // // // //                   </Select>
// // // // // // // //                 </FormControl>
// // // // // // // //               </Grid>

// // // // // // // //               <Grid item xs={12}>
// // // // // // // //                 <Button type="submit" variant="contained" fullWidth sx={{ mt: 2, py: 1.5, fontWeight: "bold", bgcolor: "#82b1ff", color: "black" }}>
// // // // // // // //                   {t("SUBMIT")}
// // // // // // // //                 </Button>
// // // // // // // //               </Grid>
// // // // // // // //             </Grid>
// // // // // // // //           </form>
// // // // // // // //         </CardContent>
// // // // // // // //       </Card>
// // // // // // // //     </Box>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // export default NewIssueScreen;


// // // // // // // import { useState, useEffect } from "react";
// // // // // // // import { 
// // // // // // //   Box, Card, CardContent, Typography, TextField, 
// // // // // // //   Button, MenuItem, Select, FormControl, InputLabel, Grid, CircularProgress 
// // // // // // // } from "@mui/material";
// // // // // // // import { useTranslation } from "react-i18next";
// // // // // // // import axiosClient from "../axiosClient";

// // // // // // // const NewIssueScreen = () => {
// // // // // // //   const { t } = useTranslation();
  
// // // // // // //   const [formData, setFormData] = useState({
// // // // // // //     title: "",
// // // // // // //     description: "",
// // // // // // //     priority: "Medium",
// // // // // // //     room_number: "",
// // // // // // //     employee_type: "", // 'TECHNICIAN' or 'MAID'
// // // // // // //     assigned_to: "",   // The specific User ID
// // // // // // //   });

// // // // // // //   const [allUsers, setAllUsers] = useState([]); 
// // // // // // //   const [filteredStaff, setFilteredStaff] = useState([]);
// // // // // // //   const [loading, setLoading] = useState(true);

// // // // // // //   // Load all users when the screen opens
// // // // // // //   useEffect(() => {
// // // // // // //     const fetchStaff = async () => {
// // // // // // //       try {
// // // // // // //         const response = await axiosClient.get("auth/users/");
// // // // // // //         setAllUsers(response.data);
// // // // // // //       } catch (err) {
// // // // // // //         console.error("Error fetching staff:", err);
// // // // // // //       } finally {
// // // // // // //         setLoading(false);
// // // // // // //       }
// // // // // // //     };
// // // // // // //     fetchStaff();
// // // // // // //   }, []);

// // // // // // //   // Update the filtered list whenever employee_type is changed
// // // // // // //   useEffect(() => {
// // // // // // //     if (formData.employee_type) {
// // // // // // //       const filtered = allUsers.filter(user => user.user_role === formData.employee_type);
// // // // // // //       setFilteredStaff(filtered);
// // // // // // //     } else {
// // // // // // //       setFilteredStaff([]);
// // // // // // //     }
// // // // // // //   }, [formData.employee_type, allUsers]);

// // // // // // //   const handleChange = (e) => {
// // // // // // //     const { name, value } = e.target;
// // // // // // //     setFormData((prev) => ({
// // // // // // //       ...prev,
// // // // // // //       [name]: value,
// // // // // // //       // If we change the type, we must reset the specific employee selection
// // // // // // //       ...(name === "employee_type" ? { assigned_to: "" } : {}),
// // // // // // //     }));
// // // // // // //   };

// // // // // // //   const handleSubmit = async (e) => {
// // // // // // //     e.preventDefault();
// // // // // // //     try {
// // // // // // //       const submitData = {
// // // // // // //         title: formData.title,
// // // // // // //         description: formData.description,
// // // // // // //         priority: formData.priority,
// // // // // // //         room_number: formData.room_number,
// // // // // // //         assigned_technician: formData.assigned_to, // Sending the ID to the backend
// // // // // // //       };
// // // // // // //       await axiosClient.post("api/issues/", submitData);
// // // // // // //       alert(t("Issue submitted successfully"));
// // // // // // //       setFormData({ title: "", description: "", priority: "Medium", room_number: "", employee_type: "", assigned_to: "" });
// // // // // // //     } catch (err) {
// // // // // // //       console.error("Error submitting issue:", err);
// // // // // // //     }
// // // // // // //   };

// // // // // // //   return (
// // // // // // //     <Box display="flex" justifyContent="center" mt={4}>
// // // // // // //       <Card sx={{ width: "100%", maxWidth: 800, elevation: 12 }}>
// // // // // // //         <CardContent>
// // // // // // //           <Typography variant="h5" mb={3} fontWeight="bold" align="center">
// // // // // // //             {t("NEW ISSUE REPORT")}
// // // // // // //           </Typography>
          
// // // // // // //           <form onSubmit={handleSubmit}>
// // // // // // //             <Grid container spacing={2}>
// // // // // // //               <Grid item xs={12} sm={8}>
// // // // // // //                 <TextField fullWidth label={t("TITLE *")} name="title" value={formData.title} onChange={handleChange} required />
// // // // // // //               </Grid>

// // // // // // //               <Grid item xs={12} sm={4}>
// // // // // // //                 <TextField fullWidth label={t("ROOM NUMBER")} name="room_number" value={formData.room_number} onChange={handleChange} placeholder="e.g. 101" />
// // // // // // //               </Grid>

// // // // // // //               <Grid item xs={12}>
// // // // // // //                 <TextField fullWidth multiline rows={4} label={t("DESCRIPTION *")} name="description" value={formData.description} onChange={handleChange} required />
// // // // // // //               </Grid>

// // // // // // //               <Grid item xs={12} sm={4}>
// // // // // // //                 <FormControl fullWidth>
// // // // // // //                   <InputLabel>{t("PRIORITY")}</InputLabel>
// // // // // // //                   <Select name="priority" value={formData.priority} label={t("PRIORITY")} onChange={handleChange}>
// // // // // // //                     <MenuItem value="Low">{t("Low")}</MenuItem>
// // // // // // //                     <MenuItem value="Medium">{t("Medium")}</MenuItem>
// // // // // // //                     <MenuItem value="High">{t("High")}</MenuItem>
// // // // // // //                   </Select>
// // // // // // //                 </FormControl>
// // // // // // //               </Grid>

// // // // // // //               {/* STEP 1: Select Employee Category */}
// // // // // // //               <Grid item xs={12} sm={4}>
// // // // // // //                 <FormControl fullWidth>
// // // // // // //                   <InputLabel>{t("EMPLOYEE TYPE")}</InputLabel>
// // // // // // //                   <Select 
// // // // // // //                     name="employee_type" 
// // // // // // //                     value={formData.employee_type} 
// // // // // // //                     label={t("EMPLOYEE TYPE")} 
// // // // // // //                     onChange={handleChange}
// // // // // // //                   >
// // // // // // //                     <MenuItem value="TECHNICIAN">{t("Technician")}</MenuItem>
// // // // // // //                     <MenuItem value="MAID">{t("Maid")}</MenuItem>
// // // // // // //                   </Select>
// // // // // // //                 </FormControl>
// // // // // // //               </Grid>

// // // // // // //               {/* STEP 2: Select Specific Staff Member */}
// // // // // // //               <Grid item xs={12} sm={4}>
// // // // // // //                 <FormControl fullWidth disabled={!formData.employee_type || loading}>
// // // // // // //                   <InputLabel>{loading ? <CircularProgress size={20} /> : t("ASSIGN TO")}</InputLabel>
// // // // // // //                   <Select 
// // // // // // //                     name="assigned_to" 
// // // // // // //                     value={formData.assigned_to} 
// // // // // // //                     label={t("ASSIGN TO")} 
// // // // // // //                     onChange={handleChange}
// // // // // // //                     required
// // // // // // //                   >
// // // // // // //                     {filteredStaff.map((staff) => (
// // // // // // //                       <MenuItem key={staff.id} value={staff.id}>
// // // // // // //                         {staff.first_name} {staff.last_name}
// // // // // // //                       </MenuItem>
// // // // // // //                     ))}
// // // // // // //                   </Select>
// // // // // // //                 </FormControl>
// // // // // // //               </Grid>

// // // // // // //               <Grid item xs={12}>
// // // // // // //                 <Button 
// // // // // // //                   type="submit" 
// // // // // // //                   variant="contained" 
// // // // // // //                   fullWidth 
// // // // // // //                   sx={{ mt: 2, py: 1.5, fontWeight: "bold" }}
// // // // // // //                 >
// // // // // // //                   {t("SUBMIT")}
// // // // // // //                 </Button>
// // // // // // //               </Grid>
// // // // // // //             </Grid>
// // // // // // //           </form>
// // // // // // //         </CardContent>
// // // // // // //       </Card>
// // // // // // //     </Box>
// // // // // // //   );
// // // // // // // };

// // // // // // // export default NewIssueScreen;

// // // // // // import { useState, useEffect } from "react";
// // // // // // import { 
// // // // // //   Box, Card, CardContent, Typography, TextField, 
// // // // // //   Button, MenuItem, Select, FormControl, InputLabel, Grid, CircularProgress, Alert
// // // // // // } from "@mui/material";
// // // // // // import { useTranslation } from "react-i18next";
// // // // // // import axiosClient from "../axiosClient";

// // // // // // const NewIssueScreen = () => {
// // // // // //   const { t } = useTranslation();
  
// // // // // //   const [formData, setFormData] = useState({
// // // // // //     title: "",
// // // // // //     description: "",
// // // // // //     priority: "Medium",
// // // // // //     room_number: "",
// // // // // //     employee_type: "", // 'TECHNICIAN' or 'MAID'
// // // // // //     assigned_to: "",   // The User ID
// // // // // //   });

// // // // // //   const [allUsers, setAllUsers] = useState([]); 
// // // // // //   const [filteredStaff, setFilteredStaff] = useState([]);
// // // // // //   const [loading, setLoading] = useState(true);
// // // // // //   const [message, setMessage] = useState(null);
// // // // // //   const [error, setError] = useState(null);

// // // // // //   // Load all users from the backend
// // // // // //   useEffect(() => {
// // // // // //     const fetchStaff = async () => {
// // // // // //       try {
// // // // // //         const response = await axiosClient.get("auth/users/");
// // // // // //         console.log("DEBUG: All users received from server:", response.data);
// // // // // //         setAllUsers(response.data);
// // // // // //       } catch (err) {
// // // // // //         console.error("Error fetching staff:", err);
// // // // // //         setError(t("Failed to load staff list"));
// // // // // //       } finally {
// // // // // //         setLoading(false);
// // // // // //       }
// // // // // //     };
// // // // // //     fetchStaff();
// // // // // //   }, [t]);

// // // // // //   // Filter staff whenever 'employee_type' or the user list changes
// // // // // //   useEffect(() => {
// // // // // //     if (formData.employee_type) {
// // // // // //       const selectedType = formData.employee_type.toUpperCase();
      
// // // // // //       const filtered = allUsers.filter(user => {
// // // // // //         // We check 'user_role' and handle potential null values or different casing
// // // // // //         const userRole = (user.user_role || "").toUpperCase().trim();
// // // // // //         return userRole === selectedType;
// // // // // //       });

// // // // // //       console.log(`DEBUG: Filtered for ${selectedType}. Found:`, filtered);
// // // // // //       setFilteredStaff(filtered);
// // // // // //     } else {
// // // // // //       setFilteredStaff([]);
// // // // // //     }
// // // // // //   }, [formData.employee_type, allUsers]);

// // // // // //   const handleChange = (e) => {
// // // // // //     const { name, value } = e.target;
// // // // // //     setFormData((prev) => ({
// // // // // //       ...prev,
// // // // // //       [name]: value,
// // // // // //       // If the type changes, we MUST reset the specific assignment
// // // // // //       ...(name === "employee_type" ? { assigned_to: "" } : {}),
// // // // // //     }));
// // // // // //   };

// // // // // //   const handleSubmit = async (e) => {
// // // // // //     e.preventDefault();
// // // // // //     setMessage(null);
// // // // // //     setError(null);

// // // // // //     if (!formData.assigned_to) {
// // // // // //       setError(t("Please select an employee to assign the task to"));
// // // // // //       return;
// // // // // //     }

// // // // // //     try {
// // // // // //       const submitData = {
// // // // // //         title: formData.title,
// // // // // //         description: formData.description,
// // // // // //         priority: formData.priority,
// // // // // //         room_number: formData.room_number,
// // // // // //         assigned_technician: formData.assigned_to, // Mapping to your backend model field
// // // // // //       };

// // // // // //       await axiosClient.post("api/issues/", submitData);
// // // // // //       setMessage(t("Issue submitted successfully"));
      
// // // // // //       // Reset form
// // // // // //       setFormData({ 
// // // // // //         title: "", 
// // // // // //         description: "", 
// // // // // //         priority: "Medium", 
// // // // // //         room_number: "", 
// // // // // //         employee_type: "", 
// // // // // //         assigned_to: "" 
// // // // // //       });
// // // // // //     } catch (err) {
// // // // // //       console.error("Error submitting issue:", err);
// // // // // //       setError(t("Error submitting issue. Please check the data."));
// // // // // //     }
// // // // // //   };

// // // // // //   return (
// // // // // //     <Box display="flex" justifyContent="center" mt={4} px={2}>
// // // // // //       <Card sx={{ width: "100%", maxWidth: 800, elevation: 12, bgcolor: "#303030", color: "white" }}>
// // // // // //         <CardContent>
// // // // // //           <Typography variant="h5" mb={3} fontWeight="bold" align="center">
// // // // // //             {t("NEW ISSUE REPORT")}
// // // // // //           </Typography>

// // // // // //           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// // // // // //           {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          
// // // // // //           <form onSubmit={handleSubmit}>
// // // // // //             <Grid container spacing={3}>
// // // // // //               {/* Title Input */}
// // // // // //               <Grid item xs={12} sm={8}>
// // // // // //                 <TextField 
// // // // // //                   fullWidth 
// // // // // //                   label={t("TITLE *")} 
// // // // // //                   name="title" 
// // // // // //                   value={formData.title} 
// // // // // //                   onChange={handleChange} 
// // // // // //                   required 
// // // // // //                   variant="outlined"
// // // // // //                   InputLabelProps={{ style: { color: "#aaa" } }}
// // // // // //                   inputProps={{ style: { color: "white" } }}
// // // // // //                 />
// // // // // //               </Grid>

// // // // // //               {/* Room Number Input */}
// // // // // //               <Grid item xs={12} sm={4}>
// // // // // //                 <TextField 
// // // // // //                   fullWidth 
// // // // // //                   label={t("ROOM NUMBER")} 
// // // // // //                   name="room_number" 
// // // // // //                   value={formData.room_number} 
// // // // // //                   onChange={handleChange} 
// // // // // //                   variant="outlined"
// // // // // //                   InputLabelProps={{ style: { color: "#aaa" } }}
// // // // // //                   inputProps={{ style: { color: "white" } }}
// // // // // //                 />
// // // // // //               </Grid>

// // // // // //               {/* Description Input */}
// // // // // //               <Grid item xs={12}>
// // // // // //                 <TextField 
// // // // // //                   fullWidth 
// // // // // //                   multiline 
// // // // // //                   rows={4} 
// // // // // //                   label={t("DESCRIPTION *")} 
// // // // // //                   name="description" 
// // // // // //                   value={formData.description} 
// // // // // //                   onChange={handleChange} 
// // // // // //                   required 
// // // // // //                   variant="outlined"
// // // // // //                   InputLabelProps={{ style: { color: "#aaa" } }}
// // // // // //                   inputProps={{ style: { color: "white" } }}
// // // // // //                 />
// // // // // //               </Grid>

// // // // // //               {/* Priority Select */}
// // // // // //               <Grid item xs={12} sm={4}>
// // // // // //                 <FormControl fullWidth variant="outlined">
// // // // // //                   <InputLabel sx={{ color: "#aaa" }}>{t("PRIORITY")}</InputLabel>
// // // // // //                   <Select 
// // // // // //                     name="priority" 
// // // // // //                     value={formData.priority} 
// // // // // //                     label={t("PRIORITY")} 
// // // // // //                     onChange={handleChange}
// // // // // //                     sx={{ color: "white", ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } }}
// // // // // //                   >
// // // // // //                     <MenuItem value="Low">{t("Low")}</MenuItem>
// // // // // //                     <MenuItem value="Medium">{t("Medium")}</MenuItem>
// // // // // //                     <MenuItem value="High">{t("High")}</MenuItem>
// // // // // //                   </Select>
// // // // // //                 </FormControl>
// // // // // //               </Grid>

// // // // // //               {/* 1. EMPLOYEE TYPE SELECT */}
// // // // // //               <Grid item xs={12} sm={4}>
// // // // // //                 <FormControl fullWidth variant="outlined">
// // // // // //                   <InputLabel sx={{ color: "#aaa" }}>{t("EMPLOYEE TYPE")}</InputLabel>
// // // // // //                   <Select 
// // // // // //                     name="employee_type" 
// // // // // //                     value={formData.employee_type} 
// // // // // //                     label={t("EMPLOYEE TYPE")} 
// // // // // //                     onChange={handleChange}
// // // // // //                     sx={{ color: "white", ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } }}
// // // // // //                   >
// // // // // //                     <MenuItem value="TECHNICIAN">{t("Technician")}</MenuItem>
// // // // // //                     <MenuItem value="MAID">{t("Maid")}</MenuItem>
// // // // // //                   </Select>
// // // // // //                 </FormControl>
// // // // // //               </Grid>

// // // // // //               {/* 2. ASSIGN TO SPECIFIC EMPLOYEE SELECT */}
// // // // // //               <Grid item xs={12} sm={4}>
// // // // // //                 <FormControl fullWidth variant="outlined" disabled={!formData.employee_type || loading}>
// // // // // //                   <InputLabel sx={{ color: formData.employee_type ? "#aaa" : "#555" }}>
// // // // // //                     {loading ? <CircularProgress size={20} /> : t("ASSIGN TO")}
// // // // // //                   </InputLabel>
// // // // // //                   <Select 
// // // // // //                     name="assigned_to" 
// // // // // //                     value={formData.assigned_to} 
// // // // // //                     label={t("ASSIGN TO")} 
// // // // // //                     onChange={handleChange}
// // // // // //                     required
// // // // // //                     sx={{ color: "white", ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } }}
// // // // // //                   >
// // // // // //                     {filteredStaff.length > 0 ? (
// // // // // //                       filteredStaff.map((staff) => (
// // // // // //                         <MenuItem key={staff.id} value={staff.id}>
// // // // // //                           {staff.first_name} {staff.last_name}
// // // // // //                         </MenuItem>
// // // // // //                       ))
// // // // // //                     ) : (
// // // // // //                       <MenuItem disabled>{t("No employees found")}</MenuItem>
// // // // // //                     )}
// // // // // //                   </Select>
// // // // // //                 </FormControl>
// // // // // //               </Grid>

// // // // // //               <Grid item xs={12}>
// // // // // //                 <Button 
// // // // // //                   type="submit" 
// // // // // //                   variant="contained" 
// // // // // //                   fullWidth 
// // // // // //                   sx={{ 
// // // // // //                     mt: 2, 
// // // // // //                     py: 1.5, 
// // // // // //                     fontWeight: "bold", 
// // // // // //                     bgcolor: "#90caf9", 
// // // // // //                     color: "black",
// // // // // //                     "&:hover": { bgcolor: "#64b5f6" }
// // // // // //                   }}
// // // // // //                 >
// // // // // //                   {t("SUBMIT ISSUE")}
// // // // // //                 </Button>
// // // // // //               </Grid>
// // // // // //             </Grid>
// // // // // //           </form>
// // // // // //         </CardContent>
// // // // // //       </Card>
// // // // // //     </Box>
// // // // // //   );
// // // // // // };

// // // // // // export default NewIssueScreen;

// // // // // import { useState, useEffect } from "react";
// // // // // import { 
// // // // //   Box, Card, CardContent, Typography, TextField, 
// // // // //   Button, MenuItem, Select, FormControl, InputLabel, Grid, CircularProgress, Alert
// // // // // } from "@mui/material";
// // // // // import { useTranslation } from "react-i18next";
// // // // // import axiosClient from "../axiosClient";

// // // // // const NewIssueScreen = () => {
// // // // //   const { t } = useTranslation();
  
// // // // //   const [formData, setFormData] = useState({
// // // // //     title: "",
// // // // //     description: "",
// // // // //     priority: "Medium",
// // // // //     room_number: "",
// // // // //     employee_type: "", // Used to switch between 'TECHNICIAN' and 'MAID'
// // // // //     assigned_to: "",   // Stores the specific employee ID
// // // // //   });

// // // // //   const [allUsers, setAllUsers] = useState([]); 
// // // // //   const [filteredStaff, setFilteredStaff] = useState([]);
// // // // //   const [loading, setLoading] = useState(true);
// // // // //   const [message, setMessage] = useState(null);
// // // // //   const [error, setError] = useState(null);

// // // // //   // Load all users from the backend
// // // // //   useEffect(() => {
// // // // //     const fetchStaff = async () => {
// // // // //       try {
// // // // //         const response = await axiosClient.get("auth/users/");
// // // // //         // We keep the whole list to filter dynamically later
// // // // //         setAllUsers(response.data);
// // // // //       } catch (err) {
// // // // //         console.error("Error fetching staff:", err);
// // // // //         setError(t("Failed to load staff list"));
// // // // //       } finally {
// // // // //         setLoading(false);
// // // // //       }
// // // // //     };
// // // // //     fetchStaff();
// // // // //   }, [t]);

// // // // //   // Update the dropdown list whenever the user switches between Technician/Maid
// // // // //   useEffect(() => {
// // // // //     if (formData.employee_type) {
// // // // //       const selectedType = formData.employee_type.toUpperCase();
      
// // // // //       const filtered = allUsers.filter(user => {
// // // // //         // Safe check for user_role to handle potential nulls or different casing
// // // // //         const userRole = (user.user_role || "").toUpperCase().trim();
// // // // //         return userRole === selectedType;
// // // // //       });

// // // // //       setFilteredStaff(filtered);
// // // // //     } else {
// // // // //       setFilteredStaff([]);
// // // // //     }
// // // // //   }, [formData.employee_type, allUsers]);

// // // // //   const handleChange = (e) => {
// // // // //     const { name, value } = e.target;
// // // // //     setFormData((prev) => ({
// // // // //       ...prev,
// // // // //       [name]: value,
// // // // //       // If we change the type (Tech/Maid), we reset the specific assignment
// // // // //       ...(name === "employee_type" ? { assigned_to: "" } : {}),
// // // // //     }));
// // // // //   };

// // // // //   const handleSubmit = async (e) => {
// // // // //     e.preventDefault();
// // // // //     setMessage(null);
// // // // //     setError(null);

// // // // //     try {
// // // // //       const submitData = {
// // // // //         title: formData.title,
// // // // //         description: formData.description,
// // // // //         priority: formData.priority,
// // // // //         room_number: formData.room_number,
// // // // //         assigned_technician: formData.assigned_to, // Mapping to your backend field
// // // // //       };

// // // // //       await axiosClient.post("api/issues/", submitData);
// // // // //       setMessage(t("Issue submitted successfully"));
      
// // // // //       setFormData({ 
// // // // //         title: "", 
// // // // //         description: "", 
// // // // //         priority: "Medium", 
// // // // //         room_number: "", 
// // // // //         employee_type: "", 
// // // // //         assigned_to: "" 
// // // // //       });
// // // // //     } catch (err) {
// // // // //       console.error("Error submitting issue:", err);
// // // // //       setError(t("Error submitting issue."));
// // // // //     }
// // // // //   };

// // // // //   return (
// // // // //     <Box display="flex" justifyContent="center" mt={4} px={2}>
// // // // //       <Card sx={{ width: "100%", maxWidth: 800, elevation: 12, bgcolor: "#24242b", color: "white" }}>
// // // // //         <CardContent>
// // // // //           <Typography variant="h5" mb={3} fontWeight="bold" align="center" sx={{ color: "#82b1ff" }}>
// // // // //             {t("Log New Issue / Ticket")}
// // // // //           </Typography>

// // // // //           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// // // // //           {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          
// // // // //           <form onSubmit={handleSubmit}>
// // // // //             <Grid container spacing={2}>
// // // // //               <Grid item xs={12} sm={8}>
// // // // //                 <TextField 
// // // // //                   fullWidth 
// // // // //                   label={t("Issue Title **")} 
// // // // //                   name="title" 
// // // // //                   value={formData.title} 
// // // // //                   onChange={handleChange} 
// // // // //                   required 
// // // // //                 />
// // // // //               </Grid>

// // // // //               <Grid item xs={12} sm={4}>
// // // // //                 <TextField 
// // // // //                   fullWidth 
// // // // //                   label={t("Room Number **")} 
// // // // //                   name="room_number" 
// // // // //                   value={formData.room_number} 
// // // // //                   onChange={handleChange} 
// // // // //                   required
// // // // //                 />
// // // // //               </Grid>

// // // // //               <Grid item xs={12}>
// // // // //                 <TextField 
// // // // //                   fullWidth 
// // // // //                   multiline 
// // // // //                   rows={4} 
// // // // //                   label={t("Description **")} 
// // // // //                   name="description" 
// // // // //                   value={formData.description} 
// // // // //                   onChange={handleChange} 
// // // // //                   required 
// // // // //                 />
// // // // //               </Grid>

// // // // //               <Grid item xs={12} sm={4}>
// // // // //                 <FormControl fullWidth>
// // // // //                   <InputLabel>{t("Priority")}</InputLabel>
// // // // //                   <Select name="priority" value={formData.priority} label={t("Priority")} onChange={handleChange}>
// // // // //                     <MenuItem value="Low">{t("Low")}</MenuItem>
// // // // //                     <MenuItem value="Medium">{t("Medium")}</MenuItem>
// // // // //                     <MenuItem value="High">{t("High")}</MenuItem>
// // // // //                   </Select>
// // // // //                 </FormControl>
// // // // //               </Grid>

// // // // //               {/* Step 1: Select between Technician or Maid */}
// // // // //               <Grid item xs={12} sm={4}>
// // // // //                 <FormControl fullWidth>
// // // // //                   <InputLabel>{t("Employee Type")}</InputLabel>
// // // // //                   <Select 
// // // // //                     name="employee_type" 
// // // // //                     value={formData.employee_type} 
// // // // //                     label={t("Employee Type")} 
// // // // //                     onChange={handleChange}
// // // // //                     required
// // // // //                   >
// // // // //                     <MenuItem value="TECHNICIAN">{t("Technician")}</MenuItem>
// // // // //                     <MenuItem value="MAID">{t("Maid")}</MenuItem>
// // // // //                   </Select>
// // // // //                 </FormControl>
// // // // //               </Grid>

// // // // //               {/* Step 2: Show specific list based on the choice above */}
// // // // //               <Grid item xs={12} sm={4}>
// // // // //                 <FormControl fullWidth disabled={!formData.employee_type || loading}>
// // // // //                   <InputLabel>{loading ? <CircularProgress size={20} /> : t("Assign To")}</InputLabel>
// // // // //                   <Select 
// // // // //                     name="assigned_to" 
// // // // //                     value={formData.assigned_to} 
// // // // //                     label={t("Assign To")} 
// // // // //                     onChange={handleChange}
// // // // //                   >
// // // // //                     <MenuItem value=""><em>None</em></MenuItem>
// // // // //                     {filteredStaff.map((staff) => (
// // // // //                       <MenuItem key={staff.id} value={staff.id}>
// // // // //                         {staff.first_name} {staff.last_name}
// // // // //                       </MenuItem>
// // // // //                     ))}
// // // // //                   </Select>
// // // // //                 </FormControl>
// // // // //               </Grid>

// // // // //               <Grid item xs={12}>
// // // // //                 <Button 
// // // // //                   type="submit" 
// // // // //                   variant="contained" 
// // // // //                   fullWidth 
// // // // //                   sx={{ mt: 2, py: 1.5, fontWeight: "bold", bgcolor: "#82b1ff", color: "black" }}
// // // // //                 >
// // // // //                   {t("CREATE ISSUE")}
// // // // //                 </Button>
// // // // //               </Grid>
// // // // //             </Grid>
// // // // //           </form>
// // // // //         </CardContent>
// // // // //       </Card>
// // // // //     </Box>
// // // // //   );
// // // // // };

// // // // // export default NewIssueScreen;
// // // // import { useState, useEffect } from "react";
// // // // import { 
// // // //   Box, Card, CardContent, Typography, TextField, 
// // // //   Button, MenuItem, Select, FormControl, InputLabel, Grid, CircularProgress, Alert
// // // // } from "@mui/material";
// // // // import { useTranslation } from "react-i18next";
// // // // import axiosClient from "../axiosClient";

// // // // const NewIssueScreen = () => {
// // // //   const { t } = useTranslation();
  
// // // //   const [formData, setFormData] = useState({
// // // //     title: "",
// // // //     description: "",
// // // //     priority: "Medium",
// // // //     room_number: "",
// // // //     employee_type: "", // STEP 1: Choose TECHNICIAN or MAID
// // // //     assigned_to: "",   // STEP 2: Choose the specific Person ID
// // // //   });

// // // //   const [allUsers, setAllUsers] = useState([]); 
// // // //   const [filteredStaff, setFilteredStaff] = useState([]);
// // // //   const [loading, setLoading] = useState(true);
// // // //   const [message, setMessage] = useState(null);
// // // //   const [error, setError] = useState(null);

// // // //   // Load all users from the backend
// // // //   useEffect(() => {
// // // //     const fetchStaff = async () => {
// // // //       try {
// // // //         const response = await axiosClient.get("auth/users/");
// // // //         setAllUsers(response.data);
// // // //       } catch (err) {
// // // //         console.error("Error fetching staff:", err);
// // // //       } finally {
// // // //         setLoading(false);
// // // //       }
// // // //     };
// // // //     fetchStaff();
// // // //   }, []);

// // // //   // This logic handles the "Maid not appearing" issue
// // // //   useEffect(() => {
// // // //     if (formData.employee_type) {
// // // //       const selectedType = formData.employee_type.toUpperCase();
      
// // // //       // We filter the big list to only show the chosen role
// // // //       const filtered = allUsers.filter(user => {
// // // //         const userRole = (user.user_role || "").toUpperCase().trim();
// // // //         return userRole === selectedType;
// // // //       });

// // // //       setFilteredStaff(filtered);
// // // //     } else {
// // // //       setFilteredStaff([]);
// // // //     }
// // // //   }, [formData.employee_type, allUsers]);

// // // //   const handleChange = (e) => {
// // // //     const { name, value } = e.target;
// // // //     setFormData((prev) => ({
// // // //       ...prev,
// // // //       [name]: value,
// // // //       // If you change the role, reset the name selection so you don't assign a Tech to a Maid role
// // // //       ...(name === "employee_type" ? { assigned_to: "" } : {}),
// // // //     }));
// // // //   };

// // // //   const handleSubmit = async (e) => {
// // // //     e.preventDefault();
// // // //     setMessage(null);
// // // //     setError(null);

// // // //     try {
// // // //       const submitData = {
// // // //         title: formData.title,
// // // //         description: formData.description,
// // // //         priority: formData.priority,
// // // //         room_number: formData.room_number,
// // // //         assigned_technician: formData.assigned_to, 
// // // //       };

// // // //       await axiosClient.post("api/issues/", submitData);
// // // //       setMessage(t("Issue submitted successfully"));
      
// // // //       setFormData({ 
// // // //         title: "", 
// // // //         description: "", 
// // // //         priority: "Medium", 
// // // //         room_number: "", 
// // // //         employee_type: "", 
// // // //         assigned_to: "" 
// // // //       });
// // // //     } catch (err) {
// // // //       setError(t("Error submitting issue."));
// // // //     }
// // // //   };

// // // //   return (
// // // //     <Box display="flex" justifyContent="center" mt={4} px={2}>
// // // //       <Card sx={{ width: "100%", maxWidth: 800, elevation: 12, bgcolor: "#24242b", color: "white" }}>
// // // //         <CardContent>
// // // //           <Typography variant="h5" mb={3} fontWeight="bold" align="center" sx={{ color: "#82b1ff" }}>
// // // //             {t("Log New Issue / Ticket")}
// // // //           </Typography>

// // // //           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// // // //           {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          
// // // //           <form onSubmit={handleSubmit}>
// // // //             <Grid container spacing={2}>
// // // //               <Grid item xs={12} sm={8}>
// // // //                 <TextField fullWidth label={t("Issue Title **")} name="title" value={formData.title} onChange={handleChange} required />
// // // //               </Grid>

// // // //               <Grid item xs={12} sm={4}>
// // // //                 <TextField fullWidth label={t("Room Number **")} name="room_number" value={formData.room_number} onChange={handleChange} required />
// // // //               </Grid>

// // // //               <Grid item xs={12}>
// // // //                 <TextField fullWidth multiline rows={4} label={t("Description **")} name="description" value={formData.description} onChange={handleChange} required />
// // // //               </Grid>

// // // //               <Grid item xs={12} sm={4}>
// // // //                 <FormControl fullWidth>
// // // //                   <InputLabel>{t("Priority")}</InputLabel>
// // // //                   <Select name="priority" value={formData.priority} label={t("Priority")} onChange={handleChange}>
// // // //                     <MenuItem value="Low">{t("Low")}</MenuItem>
// // // //                     <MenuItem value="Medium">{t("Medium")}</MenuItem>
// // // //                     <MenuItem value="High">{t("High")}</MenuItem>
// // // //                   </Select>
// // // //                 </FormControl>
// // // //               </Grid>

// // // //               {/* STEP 1: Choose TECHNICIAN or MAID */}
// // // //               <Grid item xs={12} sm={4}>
// // // //                 <FormControl fullWidth>
// // // //                   <InputLabel>{t("Employee Type")}</InputLabel>
// // // //                   <Select 
// // // //                     name="employee_type" 
// // // //                     value={formData.employee_type} 
// // // //                     label={t("Employee Type")} 
// // // //                     onChange={handleChange}
// // // //                     required
// // // //                   >
// // // //                     <MenuItem value="TECHNICIAN">{t("Technician")}</MenuItem>
// // // //                     <MenuItem value="MAID">{t("Maid")}</MenuItem>
// // // //                   </Select>
// // // //                 </FormControl>
// // // //               </Grid>

// // // //               {/* STEP 2: The List of Names (filtered based on Step 1) */}
// // // //               <Grid item xs={12} sm={4}>
// // // //                 <FormControl fullWidth disabled={!formData.employee_type || loading}>
// // // //                   <InputLabel>{loading ? <CircularProgress size={20} /> : t("Assign To")}</InputLabel>
// // // //                   <Select 
// // // //                     name="assigned_to" 
// // // //                     value={formData.assigned_to} 
// // // //                     label={t("Assign To")} 
// // // //                     onChange={handleChange}
// // // //                   >
// // // //                     <MenuItem value=""><em>None</em></MenuItem>
// // // //                     {filteredStaff.map((staff) => (
// // // //                       <MenuItem key={staff.id} value={staff.id}>
// // // //                         {staff.first_name} {staff.last_name}
// // // //                       </MenuItem>
// // // //                     ))}
// // // //                   </Select>
// // // //                 </FormControl>
// // // //               </Grid>

// // // //               <Grid item xs={12}>
// // // //                 <Button 
// // // //                   type="submit" 
// // // //                   variant="contained" 
// // // //                   fullWidth 
// // // //                   sx={{ mt: 2, py: 1.5, fontWeight: "bold", bgcolor: "#82b1ff", color: "black" }}
// // // //                 >
// // // //                   {t("CREATE ISSUE")}
// // // //                 </Button>
// // // //               </Grid>
// // // //             </Grid>
// // // //           </form>
// // // //         </CardContent>
// // // //       </Card>
// // // //     </Box>
// // // //   );
// // // // };

// // // // export default NewIssueScreen;
// // // import { useState, useEffect } from "react";
// // // import { 
// // //   Box, Card, CardContent, Typography, TextField, 
// // //   Button, MenuItem, Select, FormControl, InputLabel, Grid, CircularProgress, Alert
// // // } from "@mui/material";
// // // import { useTranslation } from "react-i18next";
// // // import axiosClient from "../axiosClient";

// // // const NewIssueScreen = () => {
// // //   const { t } = useTranslation();
  
// // //   const [formData, setFormData] = useState({
// // //     title: "",
// // //     description: "",
// // //     priority: "Medium",
// // //     room_number: "",
// // //     employee_type: "", // 'TECHNICIAN' or 'MAID'
// // //     assigned_to: "",   
// // //   });

// // //   const [allUsers, setAllUsers] = useState([]); 
// // //   const [filteredStaff, setFilteredStaff] = useState([]);
// // //   const [loading, setLoading] = useState(true);
// // //   const [message, setMessage] = useState(null);
// // //   const [error, setError] = useState(null);

// // //   // FETCH ALL USERS (This is how we get the Maids)
// // //   useEffect(() => {
// // //     const fetchStaff = async () => {
// // //       try {
// // //         const response = await axiosClient.get("auth/users/");
// // //         setAllUsers(response.data);
// // //       } catch (err) {
// // //         console.error("Error fetching staff:", err);
// // //       } finally {
// // //         setLoading(false);
// // //       }
// // //     };
// // //     fetchStaff();
// // //   }, []);

// // //   // FILTER LOGIC
// // //   useEffect(() => {
// // //     if (formData.employee_type) {
// // //       const selectedType = formData.employee_type.toUpperCase();
// // //       const filtered = allUsers.filter(user => 
// // //         (user.user_role || "").toUpperCase().trim() === selectedType
// // //       );
// // //       setFilteredStaff(filtered);
// // //     } else {
// // //       setFilteredStaff([]);
// // //     }
// // //   }, [formData.employee_type, allUsers]);

// // //   const handleChange = (e) => {
// // //     const { name, value } = e.target;
// // //     setFormData((prev) => ({
// // //       ...prev,
// // //       [name]: value,
// // //       ...(name === "employee_type" ? { assigned_to: "" } : {}),
// // //     }));
// // //   };

// // //   const handleSubmit = async (e) => {
// // //     e.preventDefault();
// // //     try {
// // //       const submitData = {
// // //         title: formData.title,
// // //         description: formData.description,
// // //         priority: formData.priority,
// // //         room_number: formData.room_number,
// // //         assigned_technician: formData.assigned_to, 
// // //       };
// // //       await axiosClient.post("api/issues/", submitData);
// // //       setMessage(t("Issue submitted successfully"));
// // //       setFormData({ title: "", description: "", priority: "Medium", room_number: "", employee_type: "", assigned_to: "" });
// // //     } catch (err) {
// // //       setError(t("Error submitting issue."));
// // //     }
// // //   };

// // //   return (
// // //     <Box display="flex" justifyContent="center" mt={4} px={2}>
// // //       <Card sx={{ width: "100%", maxWidth: 800, elevation: 12, bgcolor: "#24242b", color: "white" }}>
// // //         <CardContent>
// // //           <Typography variant="h5" mb={3} fontWeight="bold" align="center" sx={{ color: "#82b1ff" }}>
// // //             {t("Log New Issue / Ticket")}
// // //           </Typography>

// // //           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// // //           {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          
// // //           <form onSubmit={handleSubmit}>
// // //             <Grid container spacing={2}>
// // //               <Grid item xs={12} sm={8}>
// // //                 <TextField fullWidth label={t("Issue Title **")} name="title" value={formData.title} onChange={handleChange} required />
// // //               </Grid>
// // //               <Grid item xs={12} sm={4}>
// // //                 <TextField fullWidth label={t("Room Number **")} name="room_number" value={formData.room_number} onChange={handleChange} required />
// // //               </Grid>
// // //               <Grid item xs={12}>
// // //                 <TextField fullWidth multiline rows={4} label={t("Description **")} name="description" value={formData.description} onChange={handleChange} required />
// // //               </Grid>

// // //               {/* Step 1: CHOOSE TECHNICIAN OR MAID */}
// // //               <Grid item xs={12} sm={6}>
// // //                 <FormControl fullWidth>
// // //                   <InputLabel sx={{color: 'white'}}>{t("Employee Type")}</InputLabel>
// // //                   <Select 
// // //                     name="employee_type" 
// // //                     value={formData.employee_type} 
// // //                     label={t("Employee Type")} 
// // //                     onChange={handleChange}
// // //                     sx={{color: 'white', '.MuiOutlinedInput-notchedOutline': {borderColor: 'white'}}}
// // //                   >
// // //                     <MenuItem value="TECHNICIAN">{t("Technician")}</MenuItem>
// // //                     <MenuItem value="MAID">{t("Maid")}</MenuItem>
// // //                   </Select>
// // //                 </FormControl>
// // //               </Grid>

// // //               {/* Step 2: CHOOSE THE NAME (MAIDS WILL APPEAR HERE) */}
// // //               <Grid item xs={12} sm={6}>
// // //                 <FormControl fullWidth disabled={!formData.employee_type || loading}>
// // //                   <InputLabel sx={{color: formData.employee_type ? 'white' : 'gray'}}>{t("Assign To")}</InputLabel>
// // //                   <Select 
// // //                     name="assigned_to" 
// // //                     value={formData.assigned_to} 
// // //                     label={t("Assign To")} 
// // //                     onChange={handleChange}
// // //                     sx={{color: 'white', '.MuiOutlinedInput-notchedOutline': {borderColor: 'white'}}}
// // //                   >
// // //                     {filteredStaff.map((staff) => (
// // //                       <MenuItem key={staff.id} value={staff.id}>
// // //                         {staff.first_name} {staff.last_name}
// // //                       </MenuItem>
// // //                     ))}
// // //                   </Select>
// // //                 </FormControl>
// // //               </Grid>

// // //               <Grid item xs={12}>
// // //                 <Button type="submit" variant="contained" fullWidth sx={{ mt: 2, py: 1.5, fontWeight: "bold", bgcolor: "#82b1ff", color: "black" }}>
// // //                   {t("CREATE ISSUE")}
// // //                 </Button>
// // //               </Grid>
// // //             </Grid>
// // //           </form>
// // //         </CardContent>
// // //       </Card>
// // //     </Box>
// // //   );
// // // };

// // // export default NewIssueScreen;

// // // import { useState, useEffect } from "react";
// // // import { 
// // //   Box, Card, CardContent, Typography, TextField, 
// // //   Button, MenuItem, Select, FormControl, InputLabel, Grid, CircularProgress, Alert
// // // } from "@mui/material";
// // // import { useTranslation } from "react-i18next";
// // // import axiosClient from "../axiosClient";

// // // const NewIssueScreen = () => {
// // //   const { t } = useTranslation();
  
// // //   const [formData, setFormData] = useState({
// // //     title: "",
// // //     description: "",
// // //     priority: "Medium",
// // //     room_number: "",
// // //     employee_type: "", // 'TECHNICIAN' or 'MAID'
// // //     assigned_to: "",   // The specific User ID
// // //   });

// // //   const [allUsers, setAllUsers] = useState([]); 
// // //   const [filteredStaff, setFilteredStaff] = useState([]);
// // //   const [loading, setLoading] = useState(true);
// // //   const [message, setMessage] = useState(null);
// // //   const [error, setError] = useState(null);

// // //   // 1. Fetch ALL users once when the page loads
// // //   useEffect(() => {
// // //     const fetchStaff = async () => {
// // //       try {
// // //         const response = await axiosClient.get("auth/users/");
// // //         // Log to console so you can verify Maids are in the data
// // //         console.log("Staff Data Received:", response.data);
// // //         setAllUsers(response.data);
// // //       } catch (err) {
// // //         console.error("Error fetching staff:", err);
// // //       } finally {
// // //         setLoading(false);
// // //       }
// // //     };
// // //     fetchStaff();
// // //   }, []);

// // //   // 2. FILTER LOGIC: Updates the list whenever you switch Type
// // //   useEffect(() => {
// // //     if (formData.employee_type) {
// // //       const selected = formData.employee_type.toUpperCase();
      
// // //       const filtered = allUsers.filter(user => {
// // //         // We normalize the role from the backend to ensure a match
// // //         const roleFromBackend = (user.user_role || "").toUpperCase().trim();
// // //         return roleFromBackend === selected;
// // //       });
      
// // //       setFilteredStaff(filtered);
// // //     } else {
// // //       setFilteredStaff([]);
// // //     }
// // //   }, [formData.employee_type, allUsers]);

// // //   const handleChange = (e) => {
// // //     const { name, value } = e.target;
// // //     setFormData((prev) => ({
// // //       ...prev,
// // //       [name]: value,
// // //       // If the category changes, clear the specific person selection
// // //       ...(name === "employee_type" ? { assigned_to: "" } : {}),
// // //     }));
// // //   };

// // //   const handleSubmit = async (e) => {
// // //     e.preventDefault();
// // //     setMessage(null);
// // //     setError(null);

// // //     if (!formData.assigned_to) {
// // //       setError(t("Please select an employee"));
// // //       return;
// // //     }

// // //     try {
// // //       const submitData = {
// // //         title: formData.title,
// // //         description: formData.description,
// // //         priority: formData.priority,
// // //         room_number: formData.room_number,
// // //         assigned_technician: formData.assigned_to, 
// // //       };

// // //       await axiosClient.post("api/issues/", submitData);
// // //       setMessage(t("Issue submitted successfully"));
      
// // //       // Reset the form fields
// // //       setFormData({ 
// // //         title: "", 
// // //         description: "", 
// // //         priority: "Medium", 
// // //         room_number: "", 
// // //         employee_type: "", 
// // //         assigned_to: "" 
// // //       });
// // //     } catch (err) {
// // //       console.error("Submission error:", err);
// // //       setError(t("Error submitting issue."));
// // //     }
// // //   };

// // //   return (
// // //     <Box display="flex" justifyContent="center" mt={4} px={2}>
// // //       <Card sx={{ width: "100%", maxWidth: 800, elevation: 12, bgcolor: "#303030", color: "white" }}>
// // //         <CardContent>
// // //           <Typography variant="h5" mb={3} fontWeight="bold" align="center">
// // //             {t("NEW ISSUE REPORT")}
// // //           </Typography>

// // //           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// // //           {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          
// // //           <form onSubmit={handleSubmit}>
// // //             <Grid container spacing={3}>
// // //               <Grid item xs={12} sm={8}>
// // //                 <TextField 
// // //                   fullWidth 
// // //                   label={t("TITLE *")} 
// // //                   name="title" 
// // //                   value={formData.title} 
// // //                   onChange={handleChange} 
// // //                   required 
// // //                   variant="outlined"
// // //                   InputLabelProps={{style: {color: '#aaa'}}}
// // //                   inputProps={{style: {color: 'white'}}}
// // //                 />
// // //               </Grid>

// // //               <Grid item xs={12} sm={4}>
// // //                 <TextField 
// // //                   fullWidth 
// // //                   label={t("ROOM NUMBER")} 
// // //                   name="room_number" 
// // //                   value={formData.room_number} 
// // //                   onChange={handleChange} 
// // //                   variant="outlined"
// // //                   InputLabelProps={{style: {color: '#aaa'}}}
// // //                   inputProps={{style: {color: 'white'}}}
// // //                 />
// // //               </Grid>

// // //               <Grid item xs={12}>
// // //                 <TextField 
// // //                   fullWidth 
// // //                   multiline 
// // //                   rows={3} 
// // //                   label={t("DESCRIPTION *")} 
// // //                   name="description" 
// // //                   value={formData.description} 
// // //                   onChange={handleChange} 
// // //                   required 
// // //                   variant="outlined"
// // //                   InputLabelProps={{style: {color: '#aaa'}}}
// // //                   inputProps={{style: {color: 'white'}}}
// // //                 />
// // //               </Grid>

// // //               {/* STEP 1: CHOOSE EMPLOYEE TYPE (Maid or Technician) */}
// // //               <Grid item xs={12} sm={6}>
// // //                 <FormControl fullWidth variant="outlined">
// // //                   <InputLabel sx={{color: '#aaa'}}>{t("EMPLOYEE TYPE")}</InputLabel>
// // //                   <Select 
// // //                     name="employee_type" 
// // //                     value={formData.employee_type} 
// // //                     label={t("EMPLOYEE TYPE")} 
// // //                     onChange={handleChange}
// // //                     sx={{
// // //                       color: 'white', 
// // //                       '.MuiOutlinedInput-notchedOutline': {borderColor: '#555'}
// // //                     }}
// // //                   >
// // //                     <MenuItem value="TECHNICIAN">{t("Technician")}</MenuItem>
// // //                     <MenuItem value="MAID">{t("Maid")}</MenuItem>
// // //                   </Select>
// // //                 </FormControl>
// // //               </Grid>

// // //               {/* STEP 2: CHOOSE THE SPECIFIC NAME (Maids will appear here) */}
// // //               <Grid item xs={12} sm={6}>
// // //                 <FormControl fullWidth variant="outlined" disabled={!formData.employee_type || loading}>
// // //                   <InputLabel sx={{color: formData.employee_type ? '#aaa' : '#555'}}>
// // //                     {loading ? <CircularProgress size={20} /> : t("ASSIGN TO")}
// // //                   </InputLabel>
// // //                   <Select 
// // //                     name="assigned_to" 
// // //                     value={formData.assigned_to} 
// // //                     label={t("ASSIGN TO")} 
// // //                     onChange={handleChange}
// // //                     required
// // //                     sx={{
// // //                       color: 'white', 
// // //                       '.MuiOutlinedInput-notchedOutline': {borderColor: '#555'}
// // //                     }}
// // //                   >
// // //                     {filteredStaff.length > 0 ? (
// // //                       filteredStaff.map((staff) => (
// // //                         <MenuItem key={staff.id} value={staff.id}>
// // //                           {staff.first_name} {staff.last_name}
// // //                         </MenuItem>
// // //                       ))
// // //                     ) : (
// // //                       <MenuItem disabled>{t("No employees found")}</MenuItem>
// // //                     )}
// // //                   </Select>
// // //                 </FormControl>
// // //               </Grid>

// // //               <Grid item xs={12}>
// // //                 <Button 
// // //                   type="submit" 
// // //                   variant="contained" 
// // //                   fullWidth 
// // //                   sx={{ 
// // //                     mt: 2, 
// // //                     py: 1.5, 
// // //                     fontWeight: "bold", 
// // //                     bgcolor: "#90caf9", 
// // //                     color: "black",
// // //                     "&:hover": { bgcolor: "#64b5f6" }
// // //                   }}
// // //                 >
// // //                   {t("SUBMIT ISSUE")}
// // //                 </Button>
// // //               </Grid>
// // //             </Grid>
// // //           </form>
// // //         </CardContent>
// // //       </Card>
// // //     </Box>
// // //   );
// // // };

// // // export default NewIssueScreen;

// // import { useState, useEffect } from "react";
// // import { 
// //   Box, Card, CardContent, Typography, TextField, 
// //   Button, MenuItem, Select, FormControl, InputLabel, Grid, CircularProgress, Alert,
// //   Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper
// // } from "@mui/material";
// // import { useTranslation } from "react-i18next";
// // import axiosClient from "../axiosClient";

// // const NewIssueScreen = () => {
// //   const { t } = useTranslation();
  
// //   const [formData, setFormData] = useState({
// //     title: "",
// //     description: "",
// //     priority: "Medium",
// //     room_number: "",
// //     employee_type: "", 
// //     assigned_to: "",   
// //   });

// //   const [allUsers, setAllUsers] = useState([]); 
// //   const [filteredStaff, setFilteredStaff] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [message, setMessage] = useState(null);
// //   const [error, setError] = useState(null);

// //   useEffect(() => {
// //     const fetchStaff = async () => {
// //       try {
// //         const response = await axiosClient.get("auth/users/");
// //         // We ensure all roles are forced to uppercase for the filter to work
// //         const normalizedData = response.data.map(user => ({
// //             ...user,
// //             user_role: (user.user_role || "").toUpperCase().trim()
// //         }));
// //         setAllUsers(normalizedData);
// //       } catch (err) {
// //         console.error("Error fetching staff:", err);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };
// //     fetchStaff();
// //   }, []);

// //   useEffect(() => {
// //     if (formData.employee_type) {
// //       const selected = formData.employee_type.toUpperCase();
// //       const filtered = allUsers.filter(user => user.user_role === selected);
// //       setFilteredStaff(filtered);
// //     } else {
// //       setFilteredStaff([]);
// //     }
// //   }, [formData.employee_type, allUsers]);

// //   const handleChange = (e) => {
// //     const { name, value } = e.target;
// //     setFormData((prev) => ({
// //       ...prev,
// //       [name]: value,
// //       ...(name === "employee_type" ? { assigned_to: "" } : {}),
// //     }));
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     setMessage(null);
// //     setError(null);

// //     if (!formData.assigned_to) {
// //       setError(t("Please select an employee"));
// //       return;
// //     }

// //     try {
// //       const submitData = {
// //         title: formData.title,
// //         description: formData.description,
// //         priority: formData.priority,
// //         room_number: formData.room_number,
// //         assigned_technician: formData.assigned_to, 
// //       };

// //       await axiosClient.post("api/issues/", submitData);
// //       setMessage(t("Issue submitted successfully"));
// //       setFormData({ title: "", description: "", priority: "Medium", room_number: "", employee_type: "", assigned_to: "" });
// //     } catch (err) {
// //       setError(t("Error submitting issue."));
// //     }
// //   };

// //   return (
// //     <Box sx={{ p: 4 }}>
// //       <Box display="flex" justifyContent="center">
// //         <Card sx={{ width: "100%", maxWidth: 800, elevation: 12, bgcolor: "#303030", color: "white" }}>
// //           <CardContent>
// //             <Typography variant="h5" mb={3} fontWeight="bold" align="center">{t("NEW ISSUE REPORT")}</Typography>

// //             {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// //             {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            
// //             <form onSubmit={handleSubmit}>
// //               <Grid container spacing={3}>
// //                 <Grid item xs={12} sm={8}>
// //                   <TextField fullWidth label={t("TITLE *")} name="title" value={formData.title} onChange={handleChange} required variant="outlined" InputLabelProps={{style: {color: '#aaa'}}} inputProps={{style: {color: 'white'}}} />
// //                 </Grid>
// //                 <Grid item xs={12} sm={4}>
// //                   <TextField fullWidth label={t("ROOM NUMBER")} name="room_number" value={formData.room_number} onChange={handleChange} variant="outlined" InputLabelProps={{style: {color: '#aaa'}}} inputProps={{style: {color: 'white'}}} />
// //                 </Grid>
// //                 <Grid item xs={12}>
// //                   <TextField fullWidth multiline rows={3} label={t("DESCRIPTION *")} name="description" value={formData.description} onChange={handleChange} required variant="outlined" InputLabelProps={{style: {color: '#aaa'}}} inputProps={{style: {color: 'white'}}} />
// //                 </Grid>

// //                 <Grid item xs={12} sm={6}>
// //                   <FormControl fullWidth variant="outlined">
// //                     <InputLabel sx={{color: '#aaa'}}>{t("EMPLOYEE TYPE")}</InputLabel>
// //                     <Select name="employee_type" value={formData.employee_type} label={t("EMPLOYEE TYPE")} onChange={handleChange} sx={{color: 'white', '.MuiOutlinedInput-notchedOutline': {borderColor: '#555'}}}>
// //                       <MenuItem value="TECHNICIAN">{t("Technician")}</MenuItem>
// //                       <MenuItem value="MAID">{t("Maid")}</MenuItem>
// //                     </Select>
// //                   </FormControl>
// //                 </Grid>

// //                 <Grid item xs={12} sm={6}>
// //                   <FormControl fullWidth variant="outlined" disabled={!formData.employee_type || loading}>
// //                     <InputLabel sx={{color: formData.employee_type ? '#aaa' : '#555'}}>{t("ASSIGN TO")}</InputLabel>
// //                     <Select name="assigned_to" value={formData.assigned_to} label={t("ASSIGN TO")} onChange={handleChange} required sx={{color: 'white', '.MuiOutlinedInput-notchedOutline': {borderColor: '#555'}}}>
// //                       {filteredStaff.map((staff) => (
// //                         <MenuItem key={staff.id} value={staff.id}>{staff.first_name} {staff.last_name}</MenuItem>
// //                       ))}
// //                     </Select>
// //                   </FormControl>
// //                 </Grid>

// //                 <Grid item xs={12}>
// //                   <Button type="submit" variant="contained" fullWidth sx={{ mt: 2, py: 1.5, fontWeight: "bold", bgcolor: "#90caf9", color: "black" }}>
// //                     {t("SUBMIT ISSUE")}
// //                   </Button>
// //                 </Grid>
// //               </Grid>
// //             </form>
// //           </CardContent>
// //         </Card>
// //       </Box>

// //       {/* DEBUG SECTION: REMOVE THIS AFTER YOU SEE THE ROLES */}
// //       <Box mt={6}>
// //         <Typography variant="h6" color="white" gutterBottom>Debug: Database User Roles</Typography>
// //         <TableContainer component={Paper} sx={{ bgcolor: "#424242" }}>
// //           <Table size="small">
// //             <TableHead>
// //               <TableRow>
// //                 <TableCell sx={{color: "white"}}>Name</TableCell>
// //                 <TableCell sx={{color: "white"}}>Role in Database</TableCell>
// //               </TableRow>
// //             </TableHead>
// //             <TableBody>
// //               {allUsers.map((user) => (
// //                 <TableRow key={user.id}>
// //                   <TableCell sx={{color: "white"}}>{user.first_name} {user.last_name}</TableCell>
// //                   <TableCell sx={{color: "white", fontWeight: user.user_role === "MAID" ? "bold" : "normal", color: user.user_role === "MAID" ? "#90caf9" : "white"}}>
// //                     {user.user_role || "NO ROLE SET"}
// //                   </TableCell>
// //                 </TableRow>
// //               ))}
// //             </TableBody>
// //           </Table>
// //         </TableContainer>
// //       </Box>
// //     </Box>
// //   );
// // };

// // export default NewIssueScreen;

// import { useState, useEffect } from "react";
// import { 
//   Box, Card, CardContent, Typography, TextField, 
//   Button, MenuItem, Select, FormControl, InputLabel, Grid, CircularProgress, Alert
// } from "@mui/material";
// import { useTranslation } from "react-i18next";
// import axiosClient from "../axiosClient";

// const NewIssueScreen = () => {
//   const { t } = useTranslation();
  
//   const [formData, setFormData] = useState({
//     title: "",
//     description: "",
//     priority: "Medium",
//     room_number: "",
//     employee_type: "", // 'TECHNICIAN' or 'MAID'
//     assigned_to: "",   // The specific User ID
//   });

//   const [allUsers, setAllUsers] = useState([]); 
//   const [filteredStaff, setFilteredStaff] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [message, setMessage] = useState(null);
//   const [error, setError] = useState(null);

//   // Load all users on mount
//   useEffect(() => {
//     const fetchStaff = async () => {
//       try {
//         const response = await axiosClient.get("auth/users/");
//         setAllUsers(response.data);
//       } catch (err) {
//         console.error("Error fetching staff:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchStaff();
//   }, []);

//   // Filter staff based on selected type
//   useEffect(() => {
//     if (formData.employee_type) {
//       const selected = formData.employee_type.toUpperCase();
//       const filtered = allUsers.filter(user => 
//         user.user_role && user.user_role.toUpperCase() === selected
//       );
//       setFilteredStaff(filtered);
//     } else {
//       setFilteredStaff([]);
//     }
//   }, [formData.employee_type, allUsers]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//       ...(name === "employee_type" ? { assigned_to: "" } : {}),
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const submitData = {
//         title: formData.title,
//         description: formData.description,
//         priority: formData.priority,
//         room_number: formData.room_number,
//         assigned_technician: formData.assigned_to, 
//       };
//       await axiosClient.post("api/issues/", submitData);
//       setMessage(t("Issue submitted successfully"));
//       setFormData({ title: "", description: "", priority: "Medium", room_number: "", employee_type: "", assigned_to: "" });
//     } catch (err) {
//       setError(t("Error submitting issue."));
//     }
//   };

//   return (
//     <Box display="flex" justifyContent="center" mt={4} px={2}>
//       <Card sx={{ width: "100%", maxWidth: 800, elevation: 12, bgcolor: "#303030", color: "white" }}>
//         <CardContent>
//           <Typography variant="h5" mb={3} fontWeight="bold" align="center">{t("NEW ISSUE REPORT")}</Typography>

//           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
//           {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          
//           <form onSubmit={handleSubmit}>
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={8}>
//                 <TextField fullWidth label={t("TITLE *")} name="title" value={formData.title} onChange={handleChange} required variant="outlined" InputLabelProps={{style: {color: '#aaa'}}} inputProps={{style: {color: 'white'}}} />
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <TextField fullWidth label={t("ROOM NUMBER")} name="room_number" value={formData.room_number} onChange={handleChange} variant="outlined" InputLabelProps={{style: {color: '#aaa'}}} inputProps={{style: {color: 'white'}}} />
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField fullWidth multiline rows={3} label={t("DESCRIPTION *")} name="description" value={formData.description} onChange={handleChange} required variant="outlined" InputLabelProps={{style: {color: '#aaa'}}} inputProps={{style: {color: 'white'}}} />
//               </Grid>

//               {/* STEP 1: SELECT CATEGORY */}
//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel sx={{color: '#aaa'}}>{t("EMPLOYEE TYPE")}</InputLabel>
//                   <Select name="employee_type" value={formData.employee_type} label={t("EMPLOYEE TYPE")} onChange={handleChange} sx={{color: 'white', '.MuiOutlinedInput-notchedOutline': {borderColor: '#555'}}}>
//                     <MenuItem value="TECHNICIAN">{t("Technician")}</MenuItem>
//                     <MenuItem value="MAID">{t("Maid")}</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               {/* STEP 2: SELECT PERSON (Maids will show here) */}
//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth disabled={!formData.employee_type || loading}>
//                   <InputLabel sx={{color: formData.employee_type ? '#aaa' : '#555'}}>{t("ASSIGN TO")}</InputLabel>
//                   <Select name="assigned_to" value={formData.assigned_to} label={t("ASSIGN TO")} onChange={handleChange} required sx={{color: 'white', '.MuiOutlinedInput-notchedOutline': {borderColor: '#555'}}}>
//                     {filteredStaff.map((staff) => (
//                       <MenuItem key={staff.id} value={staff.id}>{staff.first_name} {staff.last_name}</MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12}>
//                 <Button type="submit" variant="contained" fullWidth sx={{ mt: 2, py: 1.5, fontWeight: "bold", bgcolor: "#90caf9", color: "black" }}>
//                   {t("SUBMIT ISSUE")}
//                 </Button>
//               </Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default NewIssueScreen;

// import { useState, useEffect } from "react";
// import { 
//   Box, Card, CardContent, Typography, TextField, 
//   Button, MenuItem, Select, FormControl, InputLabel, Grid, CircularProgress, Alert
// } from "@mui/material";
// import { useTranslation } from "react-i18next";
// import axiosClient from "../axiosClient";

// const NewIssueScreen = () => {
//   const { t } = useTranslation();
  
//   const [formData, setFormData] = useState({
//     title: "",
//     description: "",
//     priority: "Medium",
//     room_number: "",
//     employee_type: "", // 'TECHNICIAN' or 'MAID'
//     assigned_to: "",   // The specific User ID
//   });

//   const [allUsers, setAllUsers] = useState([]); 
//   const [filteredStaff, setFilteredStaff] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [message, setMessage] = useState(null);
//   const [error, setError] = useState(null);

//   // Load all users on mount
//   useEffect(() => {
//     const fetchStaff = async () => {
//       try {
//         const response = await axiosClient.get("auth/users/");
//         setAllUsers(response.data);
//       } catch (err) {
//         console.error("Error fetching staff:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchStaff();
//   }, []);

//   // Filter staff based on selected type
//   useEffect(() => {
//     if (formData.employee_type) {
//       const selected = formData.employee_type.toUpperCase();
//       const filtered = allUsers.filter(user => 
//         user.user_role && user.user_role.toUpperCase() === selected
//       );
//       setFilteredStaff(filtered);
//     } else {
//       setFilteredStaff([]);
//     }
//   }, [formData.employee_type, allUsers]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//       ...(name === "employee_type" ? { assigned_to: "" } : {}),
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const submitData = {
//         title: formData.title,
//         description: formData.description,
//         priority: formData.priority,
//         room_number: formData.room_number,
//         assigned_technician: formData.assigned_to, 
//       };
//       await axiosClient.post("api/issues/", submitData);
//       setMessage(t("Issue submitted successfully"));
//       setFormData({ title: "", description: "", priority: "Medium", room_number: "", employee_type: "", assigned_to: "" });
//     } catch (err) {
//       setError(t("Error submitting issue."));
//     }
//   };

//   return (
//     <Box display="flex" justifyContent="center" mt={4} px={2}>
//       <Card sx={{ width: "100%", maxWidth: 800, elevation: 12, bgcolor: "#303030", color: "white" }}>
//         <CardContent>
//           <Typography variant="h5" mb={3} fontWeight="bold" align="center">{t("NEW ISSUE REPORT")}</Typography>

//           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
//           {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          
//           <form onSubmit={handleSubmit}>
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={8}>
//                 <TextField fullWidth label={t("TITLE *")} name="title" value={formData.title} onChange={handleChange} required variant="outlined" InputLabelProps={{style: {color: '#aaa'}}} inputProps={{style: {color: 'white'}}} />
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <TextField fullWidth label={t("ROOM NUMBER")} name="room_number" value={formData.room_number} onChange={handleChange} variant="outlined" InputLabelProps={{style: {color: '#aaa'}}} inputProps={{style: {color: 'white'}}} />
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField fullWidth multiline rows={3} label={t("DESCRIPTION *")} name="description" value={formData.description} onChange={handleChange} required variant="outlined" InputLabelProps={{style: {color: '#aaa'}}} inputProps={{style: {color: 'white'}}} />
//               </Grid>

//               {/* STEP 1: SELECT CATEGORY */}
//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel sx={{color: '#aaa'}}>{t("EMPLOYEE TYPE")}</InputLabel>
//                   <Select name="employee_type" value={formData.employee_type} label={t("EMPLOYEE TYPE")} onChange={handleChange} sx={{color: 'white', '.MuiOutlinedInput-notchedOutline': {borderColor: '#555'}}}>
//                     <MenuItem value="TECHNICIAN">{t("Technician")}</MenuItem>
//                     <MenuItem value="MAID">{t("Maid")}</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               {/* STEP 2: SELECT PERSON (Maids will show here) */}
//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth disabled={!formData.employee_type || loading}>
//                   <InputLabel sx={{color: formData.employee_type ? '#aaa' : '#555'}}>{t("ASSIGN TO")}</InputLabel>
//                   <Select name="assigned_to" value={formData.assigned_to} label={t("ASSIGN TO")} onChange={handleChange} required sx={{color: 'white', '.MuiOutlinedInput-notchedOutline': {borderColor: '#555'}}}>
//                     {filteredStaff.map((staff) => (
//                       <MenuItem key={staff.id} value={staff.id}>{staff.first_name} {staff.last_name}</MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12}>
//                 <Button type="submit" variant="contained" fullWidth sx={{ mt: 2, py: 1.5, fontWeight: "bold", bgcolor: "#90caf9", color: "black" }}>
//                   {t("SUBMIT ISSUE")}
//                 </Button>
//               </Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default NewIssueScreen;


/////////////////////////////


// import { useState, useEffect } from "react";
// import { 
//   Box, Card, CardContent, Typography, TextField, 
//   Button, MenuItem, Select, FormControl, InputLabel, Grid, CircularProgress, Alert
// } from "@mui/material";
// import { useTranslation } from "react-i18next";
// import axiosClient from "../axiosClient";

// const NewIssueScreen = () => {
//   const { t } = useTranslation();
  
//   const [formData, setFormData] = useState({
//     title: "",
//     description: "",
//     priority: "Medium",
//     room_number: "",
//     employee_type: "", 
//     assigned_to: "",   
//     // 🛠️ ADDED: Starting Date field
//     start_date: "", 
//   });

//   const [allUsers, setAllUsers] = useState([]); 
//   const [filteredStaff, setFilteredStaff] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [message, setMessage] = useState(null);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchStaff = async () => {
//       try {
//         const response = await axiosClient.get("auth/users/");
//         setAllUsers(response.data);
//       } catch (err) {
//         console.error("Error fetching staff:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchStaff();
//   }, []);

//   useEffect(() => {
//     if (formData.employee_type) {
//       const selected = formData.employee_type.toUpperCase();
//       const filtered = allUsers.filter(user => 
//         user.user_role && user.user_role.toUpperCase() === selected
//       );
//       setFilteredStaff(filtered);
//     } else {
//       setFilteredStaff([]);
//     }
//   }, [formData.employee_type, allUsers]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//       ...(name === "employee_type" ? { assigned_to: "" } : {}),
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const submitData = {
//         title: formData.title,
//         description: formData.description,
//         priority: formData.priority,
//         room_number: formData.room_number,
//         assigned_technician: formData.assigned_to,
//         // 🛠️ ADDED: Passing start_date to the API to populate the calendar/list
//         created_at: formData.start_date, 
//       };
//       await axiosClient.post("api/issues/", submitData);
//       setMessage(t("Issue submitted successfully and added to calendar"));
//       // Reset form including start_date
//       setFormData({ 
//         title: "", description: "", priority: "Medium", 
//         room_number: "", employee_type: "", assigned_to: "", 
//         start_date: "" 
//       });
//     } catch (err) {
//       setError(t("Error submitting issue."));
//     }
//   };

//   return (
//     <Box display="flex" justifyContent="center" mt={4} px={2}>
//       <Card sx={{ width: "100%", maxWidth: 800, elevation: 12, bgcolor: "#303030", color: "white" }}>
//         <CardContent>
//           <Typography variant="h5" mb={3} fontWeight="bold" align="center">{t("NEW ISSUE REPORT")}</Typography>

//           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
//           {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          
//           <form onSubmit={handleSubmit}>
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={8}>
//                 <TextField fullWidth label={t("TITLE *")} name="title" value={formData.title} onChange={handleChange} required variant="outlined" InputLabelProps={{style: {color: '#aaa'}}} inputProps={{style: {color: 'white'}}} />
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <TextField fullWidth label={t("ROOM NUMBER")} name="room_number" value={formData.room_number} onChange={handleChange} variant="outlined" InputLabelProps={{style: {color: '#aaa'}}} inputProps={{style: {color: 'white'}}} />
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField fullWidth multiline rows={3} label={t("DESCRIPTION *")} name="description" value={formData.description} onChange={handleChange} required variant="outlined" InputLabelProps={{style: {color: '#aaa'}}} inputProps={{style: {color: 'white'}}} />
//               </Grid>

//               {/* 🛠️ NEW FIELD: STARTING DATE (Added to Calendar) */}
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   label={t("STARTING DATE (ADD TO CALENDAR) *")}
//                   name="start_date"
//                   type="datetime-local"
//                   value={formData.start_date}
//                   onChange={handleChange}
//                   required
//                   variant="outlined"
//                   InputLabelProps={{ shrink: true, style: { color: '#aaa' } }}
//                   inputProps={{ style: { color: 'white' } }}
//                   sx={{ '.MuiOutlinedInput-notchedOutline': { borderColor: '#555' } }}
//                 />
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel sx={{color: '#aaa'}}>{t("EMPLOYEE TYPE")}</InputLabel>
//                   <Select name="employee_type" value={formData.employee_type} label={t("EMPLOYEE TYPE")} onChange={handleChange} sx={{color: 'white', '.MuiOutlinedInput-notchedOutline': {borderColor: '#555'}}}>
//                     <MenuItem value="TECHNICIAN">{t("Technician")}</MenuItem>
//                     <MenuItem value="MAID">{t("Maid")}</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth disabled={!formData.employee_type || loading}>
//                   <InputLabel sx={{color: formData.employee_type ? '#aaa' : '#555'}}>{t("ASSIGN TO")}</InputLabel>
//                   <Select name="assigned_to" value={formData.assigned_to} label={t("ASSIGN TO")} onChange={handleChange} required sx={{color: 'white', '.MuiOutlinedInput-notchedOutline': {borderColor: '#555'}}}>
//                     {filteredStaff.map((staff) => (
//                       <MenuItem key={staff.id} value={staff.id}>{staff.first_name} {staff.last_name}</MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12}>
//                 <Button type="submit" variant="contained" fullWidth sx={{ mt: 2, py: 1.5, fontWeight: "bold", bgcolor: "#90caf9", color: "black" }}>
//                   {t("SUBMIT ISSUE")}
//                 </Button>
//               </Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default NewIssueScreen;

//////////////////


import { useState, useEffect } from "react";
import { 
  Box, Card, CardContent, Typography, TextField, 
  Button, MenuItem, Select, FormControl, InputLabel, Grid, CircularProgress, Alert
} from "@mui/material";
import { useTranslation } from "react-i18next";
import axiosClient from "../axiosClient";

const NewIssueScreen = () => {
  const { t } = useTranslation();
  
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    priority: "Medium",
    room_number: "",
    employee_type: "", 
    assigned_to: "",   
    start_date: "", // 🛠️ Field for Calendar sync
  });

  const [allUsers, setAllUsers] = useState([]); 
  const [filteredStaff, setFilteredStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const response = await axiosClient.get("auth/users/");
        setAllUsers(response.data);
      } catch (err) {
        console.error("Error fetching staff:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchStaff();
  }, []);

  useEffect(() => {
    if (formData.employee_type) {
      const selected = formData.employee_type.toUpperCase();
      const filtered = allUsers.filter(user => 
        user.user_role && user.user_role.toUpperCase() === selected
      );
      setFilteredStaff(filtered);
    } else {
      setFilteredStaff([]);
    }
  }, [formData.employee_type, allUsers]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "employee_type" ? { assigned_to: "" } : {}),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const submitData = {
        title: formData.title,
        description: formData.description,
        priority: formData.priority,
        room_number: formData.room_number,
        assigned_technician: formData.assigned_to,
        // 🛠️ Passing start_date to backend
        created_at: formData.start_date, 
      };
      await axiosClient.post("api/issues/", submitData);
      setMessage(t("Issue submitted successfully and added to calendar"));
      setFormData({ title: "", description: "", priority: "Medium", room_number: "", employee_type: "", assigned_to: "", start_date: "" });
    } catch (err) {
      setError(t("Error submitting issue."));
    }
  };

  return (
    <Box display="flex" justifyContent="center" mt={4} px={2}>
      <Card sx={{ width: "100%", maxWidth: 800, elevation: 12, bgcolor: "#303030", color: "white" }}>
        <CardContent>
          <Typography variant="h5" mb={3} fontWeight="bold" align="center">{t("NEW ISSUE REPORT")}</Typography>
          {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={8}>
                <TextField fullWidth label={t("TITLE *")} name="title" value={formData.title} onChange={handleChange} required variant="outlined" InputLabelProps={{style: {color: '#aaa'}}} inputProps={{style: {color: 'white'}}} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField fullWidth label={t("ROOM NUMBER")} name="room_number" value={formData.room_number} onChange={handleChange} variant="outlined" InputLabelProps={{style: {color: '#aaa'}}} inputProps={{style: {color: 'white'}}} />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth multiline rows={3} label={t("DESCRIPTION *")} name="description" value={formData.description} onChange={handleChange} required variant="outlined" InputLabelProps={{style: {color: '#aaa'}}} inputProps={{style: {color: 'white'}}} />
              </Grid>

              {/* 🛠️ STARTING DATE (SYNC TO CALENDAR) */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={t("STARTING DATE (ADD TO CALENDAR) *")}
                  name="start_date"
                  type="datetime-local"
                  value={formData.start_date}
                  onChange={handleChange}
                  required
                  variant="outlined"
                  InputLabelProps={{ shrink: true, style: { color: '#aaa' } }}
                  inputProps={{ style: { color: 'white' } }}
                  sx={{ '.MuiOutlinedInput-notchedOutline': { borderColor: '#555' } }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel sx={{color: '#aaa'}}>{t("EMPLOYEE TYPE")}</InputLabel>
                  <Select name="employee_type" value={formData.employee_type} label={t("EMPLOYEE TYPE")} onChange={handleChange} sx={{color: 'white', '.MuiOutlinedInput-notchedOutline': {borderColor: '#555'}}}>
                    <MenuItem value="TECHNICIAN">{t("Technician")}</MenuItem>
                    <MenuItem value="MAID">{t("Maid")}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth disabled={!formData.employee_type || loading}>
                  <InputLabel sx={{color: formData.employee_type ? '#aaa' : '#555'}}>{t("ASSIGN TO")}</InputLabel>
                  <Select name="assigned_to" value={formData.assigned_to} label={t("ASSIGN TO")} onChange={handleChange} required sx={{color: 'white', '.MuiOutlinedInput-notchedOutline': {borderColor: '#555'}}}>
                    {filteredStaff.map((staff) => (
                      <MenuItem key={staff.id} value={staff.id}>{staff.first_name} {staff.last_name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Button type="submit" variant="contained" fullWidth sx={{ mt: 2, py: 1.5, fontWeight: "bold", bgcolor: "#90caf9", color: "black" }}>
                  {t("SUBMIT ISSUE")}
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
};

export default NewIssueScreen;